import React, { useState, useEffect, useCallback, useMemo } from "react";
import { Dropdown, Spinner } from "react-bootstrap";
import { useDropzone } from "react-dropzone";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { captureException } from "@sentry/browser";
import Modal from "react-modal";
import ModalBootstrap from "react-bootstrap/Modal";
import PTextareaChat from "../../common/PTextareaChat";
import PTextareaBroadcast from "../../common/PTextareaBroadcast";
import ChatMessage from "./chatmessage";
import Mute from "./mute";
import NewMessageUserMultiSelect from "./NewMessageUserMultiSelect";
import { ROLES } from "../../utils/constants";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import AlertConfirm from "../../common/AlertConfirmModal";
import PRainbowToast from "../../common/PRainbowToast";
import { useToasts } from "react-toast-notifications";
import { CopyToClipboard } from "react-copy-to-clipboard";
import $ from "jquery";
import { connect, useDispatch } from "react-redux";
import { useHistory, useLocation } from "react-router";
import Stash from "../../common/Stash";
import {
    setChatGalleryActiveMessage,
    setChatGalleryMessages,
    setChatGallerySource,
    setShowChatGallery,
} from "../../../redux/actions/chatGallery";

import {
    updateShowPriceR,
    updateMute,
    updateMuteOther,
    updateMsgOptionOpenR,
    updateBroadcastMsgR,
    updateImageModalSrcR,
    updateshowVideoModalR,
    setContainerClass,
    updateShowImageModalR,
    setStashModal,
    setOrderModal,
    setActiveAlbum,
    updateActiveConvR,
    setBroadcastModal,
    setSettings,
    setAlert,
    updateConvListR,
    setConvIndexR,
    setMessages,
    updateBroadcastIndicator,
} from "../../../redux/actions";
import {
    asyncDebouncer,
    bytesToSize,
    checkAspectRatio,
    toFixedTrunc,
    splitTime,
} from "../../utils/helper";
import { ppvPrice as DefaultPpvPrice } from "../../utils/rules";
import currency from "currency.js";
import OrderModal from "./OrderModal";
import { isDesktop, isMobile } from "react-device-detect";
import useDidMountEffect from "../../utils/useDidMountEffect";
import moment from "moment";
import BroadcastFilter from "./broadcast-filter";
import PAlert from "../../common/PAlert";
import CloseButton from "../../common/CloseButton";

import "react-datepicker/dist/react-datepicker.css";
import Exclude from "./Exclude";
import PriceV2 from "../../common/PriceV2";
import { v4 as uuidv4 } from "uuid";
import StashSelected from "./stash-selected";
import PpvStatistics from "./PpvStatistics";
import Avatar from "../../common/Avatar";
import {
    setStash,
    setStashSelectedR,
    setStashShow,
    setStashSidebar,
    setStashTabSelected,
    setTempSelected,
} from "../../../redux/actions/stash";
import {
    setActivePersonalNote,
    setPersonalNoteIsOpen,
} from "../../../redux/actions/notes";
import PersonalNotes from "./PersonalNotes";
import ChatGallery from "../../common/ChatGallery";
import BlockUser from "./block-user";
import UnblockUser from "./unblock-user";
import { MessageContext } from "./MessageContext";
import Echo from "laravel-echo";
import ModalPPVPrice from "../../common/ModalPPVPrice";
import { ModalPPVPriceContext } from "../../common/ModalPPVPrice/context";
import styled from "styled-components";
import CountDownTimer from "../../common/CountDownTimer";
import PriceText from "../../common/PriceText";
import { Checkbox, FormGroup, IconButton } from "@mui/material";
import { toggleUserListModal } from "../../../redux/actions/userLists";
import AddUserFromModal from "../../common/UserLists/AddUserFromModal";
import { Divider } from "@material-ui/core";
import { Button } from "@mui/material";
import UserListsFilter from "./UserListsFilter";
import { resetMessageUserListsFilter } from "../../../redux/actions/message";
/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

Modal.setAppElement("#chat_cont");

const PriceInformation = styled.div`
    background-color: #eee;
    color: #0097fe;
    padding: 8px 8px 8px 16px;
    margin: 8px 0;
    position: relative;
    border-radius: 25px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
`;

const ClosePriceInformation = styled.span``;

const currencyFormat = {
    precision: 2,
};

const MessengerContainer = ({
    messageUserListsFilterRdx,
    userListModalRdx,
    presence,
    setStashShow,
    show,
    setStash,
    setActive,
    active = null,
    updateBroadcastMsg,
    msgModalIsOpen,
    setMsgModalIsOpen,
    refreshConvList,
    setRefreshConvList,
    setShowMobileChat,
    stashSelected,
    setStashSelected,
    updateShowPrice,
    showPrice,
    muteVal,
    updateMuteHere,
    updateConvList,
    msgOptionOpen,
    updateMsgOptionOpen,
    muteOtherVal,
    updateMuteOtherHere,
    updateImageModalSrc,
    updateshowVideoModal,
    setContainerClass,
    updateShowImageModal,
    activeConv,
    setStashModal,
    stashModal,
    setOrderModal,
    orderModal,
    activeAlbum,
    setActiveAlbum,
    updateActiveConv,
    stashSidebar,
    setStashSidebar,
    convIndex,
    convList,
    broadcastModal,
    setBroadcastModal,
    setSettings,
    settings,
    openNotes,
    showChatGallery,
    setConvIndex,
    setChatWindow,
    messages,
    chatGallerySource,
    updateBroadcastIndicator,
    setStashTabSelected,
}) => {
    const { addToast } = useToasts();

    const dispatch = useDispatch();
    const search = useLocation().search;
    const searchParams = new URLSearchParams(search);
    const location = useLocation();
    const history = useHistory();

    const [processingIntent, setProcessingIntent] = useState(false);
    const [intentCompleted, setintentCompleted] = useState(false);
    const [loading, setLoading] = useState(false);
    const [loadingStash, setLoadingStash] = useState(false);
    const [progressbar, setProgressbar] = useState(0);
    const [statsLogin, setStatsLogin] = useState("");
    const [fileLoadingText, setFileLoadingText] = useState("");
    const [mediaSent, setMediaSent] = useState([]);
    const [statsListInfoModalIsOpen, setStatsListInfoModalIsOpen] =
        useState(false);
    const [nextLoading, setNextLoading] = useState(false);
    const [showMessages, setShowMessages] = useState(false);
    const [pauseStashLoadMore, setPauseStashLoadMore] = useState(false);
    const [stashEnd, setStashEnd] = useState(false);
    const [isAddingToAlbum, setIsAddingToAlbum] = useState(false);
    const [expandBroadcasts, setExpandBroadcasts] = useState([]);
    const [chatPlaceholder, setChatPlaceholder] = useState(
        "Type your message.."
    );
    const [firstPageLoaded, setFirstPageLoaded] = useState(false); // is used to prevent scrolling bottom when there's no more messages and there's less than 16 messages
    const [files, setAttach] = useState([]);
    const [removedBroadcasts, setRemovedBroadcasts] = useState([]);
    const [newMsgSendSelected, setNewMsgSendSelected] = useState([]);
    const [mediaFiles, setMediaFiles] = useState([]);
    const [albumList, setAlbumList] = useState([]);
    const [scrollBottomTrigger, setScrollBottomTrigger] = useState(false);
    const [sending, setSending] = useState(false);
    const [moveAlbumList, setMoveAlbumList] = useState([]);
    const [images, setImages] = useState([]);
    const [newSubsError, setNewSubsError] = useState("");
    const [confirmAlbumID, setConfirmAlbumID] = useState("");
    const [statsType, setStatsType] = useState("");
    const [message, setMessage] = useState("");
    const [ppvFilter, setPpvFilter] = useState("");
    const [broadcastMessage, setBroadcastMessage] = useState("");
    const [albumName, setAlbumName] = useState("");
    const [editAlbum, setEditAlbum] = useState("");
    const [editAlbumName, setEditAlbumName] = useState("");
    const [stashFilter, setStashFilter] = useState("");
    const [mediaOrAlbum, setMediaOrAlbum] = useState("media");
    const [renameAlbum, setRenameAlbum] = useState("");
    const [addMediaAlbum, setAddMediaAlbum] = useState("");
    const [openModalBroadcast, setOpenModalBroadcast] = useState(false);
    const [newMsgStep, setNewMsgStep] = useState("1");
    const [modalIsOpen, setIsOpen] = useState(false);
    const [ppvPrice, setPpvPrice] = useState(0);
    const [uploading, setUploading] = useState(true);
    const [showLoader, setShowLoader] = useState(false);
    const [lastHrs, setLastHrs] = useState(24);
    const [lastSubsParent, setLastSubsParent] = useState(1);
    const [pastHoursParent, setPastHoursParent] = useState(1);
    const [progress, setProgress] = useState(0);
    const [caption, setCaption] = useState("");
    const [showAlert, setShowAlert] = useState(false);
    const [modalBody, setModalBody] = useState("");
    const [hasConfirm, setHasConfirmation] = useState(false);
    const [confirmAction, setConfirmAction] = useState(false);
    const [showCreateAlbum, setShowCreateAlbum] = useState(false);
    const [showRenameFolder, setShowRenameFolder] = useState(false);
    const [showMoveFolder, setShowMoveFolder] = useState(false);
    const [newMessageSelect, setNewMessageSelect] = useState(0);
    const [showToast, setShowToast] = useState(false);
    const [showBlockModal, setShowBlockModal] = useState(false);
    const [showStatsModal, setShowStatsModal] = useState(false);
    const [favourite, setFavourite] = useState(false);
    const [userDetails, setUserDetails] = useState([]);
    const [newMsgChecked, setNewMsgChecked] = useState("");
    const [pauseLoadMore, setpauseLoadMore] = useState(false); // used to disable auto trigger of load more when loading messages
    const [ppvPriceError, setPpvPriceError] = useState(false);
    const [newLineCount, setNewLineCount] = useState(1);
    const [mediaSold, setMediaSold] = useState([]);
    const [userCount, setUserCount] = useState(0);
    const [blockedUsers, setBlockedUsers] = useState([]);
    const [busyBlocks, setBusyBlocks] = useState(false);
    const [excludeList, setExcludeList] = useState([]);
    const [tmpStashSelection, setTmpStashSelection] = useState([]);
    const [isUploading, setIsUploading] = useState(false);
    const [newMessage, setNewMessage] = useState(0);
    const [uuid, setUuid] = useState("");
    const [responseMessage, setResponseMessage] = useState({});
    const [loadMessageTrigger, setLoadMessageTrigger] = useState(0);
    const [broadcastProgress, setBroadcastProgress] = useState(0);
    const [broadcastId, setBroadcastId] = useState("");
    const [isSendingBroadcast, setIsSendingBroadcast] = useState(false);
    const [followStatus, setFollowStatus] = useState("");
    const [sendBy, setSendBy] = useState("sub_id");
    const [isOnline, setIsOnline] = useState(false);
    const [onComposeMessage, setOnComposeMessage] = useState(false);
    const [promoPrice, setPromoPrice] = useState("");
    const [isDiscounted, setIsDiscounted] = useState(false);
    const [prevPpvPrice, setPrevPpvPrice] = useState("");
    const [prevPromoPrice, setPrevPromoPrice] = useState("");
    const [prevIsDiscounted, setPrevIsDiscounted] = useState(false);
    // const [showPriceInfo, setShowPriceInfo] = useState(false);
    const [expiry, setExpiry] = useState({
        days: 0,
        hours: 0,
        minutes: 0,
    });
    const [prevExpiry, setPrevExpiry] = useState({
        days: 0,
        hours: 0,
        minutes: 0,
    });
    const [sendEmail, setSendEmail] = useState(false);

    const userInformation = JSON.parse(localStorage.getItem("user"));
    // const countDownExpiryDate = moment().add(expiry.days, 'days').add(expiry.hours, 'hours').add(expiry.minutes, 'minutes');

    const getBlockedUsers = async () => {
        setBusyBlocks(true);
        await axios
            .get("/api/blocks")
            .then((response) => {
                setBlockedUsers(response.data);
                setBusyBlocks(false);
            })
            .catch((error) => {
                setBusyBlocks(false);
                captureException(error);
            });
    };

    const [selectedFilter, setSelectedFilter] = useState("");
    const [rangeIdFromParent, setRangeIdFromParent] = useState("");
    const [rangeIdToParent, setRangeIdToParent] = useState("");
    const [rangeDateFromParent, setRangeDateFromParent] = useState("");
    const [rangeDateToParent, setRangeDateToParent] = useState("");
    const [showUnblockModal, setShowUnblockModal] = useState(false);

    const dispatchAlert = (body, type, title = "") => {
        dispatch(
            setAlert({
                body,
                type,
                title,
                show: true,
            })
        );
    };

    const handleUnblock = () => {
        setShowUnblockModal((showUnblockModal) => !showUnblockModal);
    };

    const handleBlockModal = () => {
        setShowBlockModal(!showBlockModal);
    };

    const handleSelectedFilter = useCallback((value) => {
        setSelectedFilter(value);
        setNewMsgChecked(value);
    }, []);

    const handleNextStep = (e) => {
        const count = newMsgSendSelected.length;
        if (newMsgChecked === "new") {
            // check new subscribers only
            axios
                .get("/api/fetchConvs", {
                    params: {
                        user_filter: newMsgChecked,
                        last_hrs: lastHrs,
                    },
                })
                .then(({ data }) => {
                    setNextLoading(false);

                    if (data.data.length == 0) {
                        setNewMsgSendSelected([]);
                        if (newMsgChecked != "new") {
                            setNewMsgChecked("");
                        }

                        axios
                            .get("/api/fetch-latest-sub", {
                                params: {
                                    user_filter: newMsgChecked,
                                    last_hrs: lastHrs,
                                },
                            })
                            .then(({ data }) => {
                                if (data.hours_diff > 0) {
                                    const timeDiff = splitTime(data.hours_diff);
                                    let inWords = "";
                                    if (timeDiff.days) {
                                        inWords += `${timeDiff.days} day${
                                            timeDiff.days > 1 ? "s" : ""
                                        }`;
                                    }
                                    if (timeDiff.hours) {
                                        inWords += ` ${timeDiff.hours} hour${
                                            timeDiff.hours > 1 ? "s" : ""
                                        }`;
                                    }
                                    if (timeDiff.minutes) {
                                        inWords += ` and ${
                                            timeDiff.minutes
                                        } minute${
                                            timeDiff.minutes > 1 ? "s" : ""
                                        }`;
                                    }
                                    addToast(
                                        `No new subscribers in last ${data.last_hours} hour(s). The last user subscribed ${inWords} ago`,
                                        {
                                            appearance: "success",
                                            autoDismiss: false,
                                        }
                                    );
                                } else {
                                    addToast("No followers found.", {
                                        appearance: "success",
                                        autoDismiss: false,
                                    });
                                }
                            })
                            .catch((error) => {
                                captureException(error);
                                addToast("No followers found.", {
                                    appearance: "success",
                                    autoDismiss: false,
                                });
                            });
                    } else {
                        setUserCount(data.data.length);
                        setNewMsgStep("2");
                    }
                })
                .catch((error) => {
                    captureException(error);
                });
        } else if (newMsgChecked == "new_last_subs") {
            axios
                .get("/api/fetch-latest-sub", {
                    params: {
                        user_filter: newMsgChecked,
                        last_subs: lastSubs,
                    },
                })
                .then(({ data }) => {
                    if (data.active <= 0) {
                        addToast("You have no subscribed followers", {
                            appearance: "success",
                            autoDismiss: true,
                        });
                    } else {
                        if (lastSubs > data.active) {
                            setLastSubs(data.active);
                            setUserCount(lastSubs);
                        } else {
                            setUserCount(lastSubs);
                        }
                        setNewMsgStep("2");
                    }
                })
                .catch((error) => {
                    captureException(error);
                    addToast("You have no subscribed followers", {
                        appearance: "success",
                        autoDismiss: true,
                    });
                });
        } else if (newMsgChecked === "unsubscribed") {
            setNextLoading(true);

            axios
                .get("/api/fetchConvs", {
                    params: {
                        user_filter: newMsgChecked,
                    },
                })
                .then(({ data }) => {
                    setNextLoading(false);
                    if (data && data.data.length > 0) {
                        setNewSubsError("");
                        const setSendList = data.data.map((i) => ({
                            name: i.other_user,
                            id: i.other_user_id,
                        }));
                        setUserCount(data.data.length);
                        setNewMsgStep("2");
                    } else {
                        addToast("You have no unsubscribed followers", {
                            appearance: "success",
                            autoDismiss: true,
                        });
                        setNewMsgStep("1");
                    }
                })
                .catch((error) => {
                    captureException(error);
                    setNextLoading(false);
                });
        } else if (newMsgChecked == "favourites") {
            setNextLoading(true);

            axios
                .get("/api/fetchConvs", {
                    params: {
                        user_filter: newMsgChecked,
                    },
                })
                .then(({ data }) => {
                    setNextLoading(false);
                    if (data.data && data.data.length > 0) {
                        setNewSubsError("");
                        setUserCount(data.data.length);
                        setNewMsgStep("2");
                    } else {
                        addToast("You have no favourite followers", {
                            appearance: "success",
                            autoDismiss: true,
                        });
                        setNewMsgStep("1");
                    }
                })
                .catch((error) => {
                    captureException(error);
                    setNextLoading(false);
                });
        } else if (
            newMsgChecked === "subs_range_date" ||
            newMsgChecked === "subs_range_id"
        ) {
            let params = {
                user_filter: newMsgChecked,
            };
            params =
                newMsgChecked === "subs_range_id"
                    ? {
                          ...params,
                          range_id_from: rangeIdFrom,
                          range_id_to: rangeIdTo,
                      }
                    : {
                          ...params,
                          range_date_from: rangeDateFrom,
                          range_date_to: rangeDateTo,
                      };
            axios
                .get("/api/fetch-latest-sub", {
                    params,
                })
                .then(({ data }) => {
                    if (data.data && data.data.length > 0) {
                        setUserCount(data.data.length);
                        setNewMsgStep("2");
                    } else {
                        addToast(
                            "You have no subscribed followers for selected range.",
                            { appearance: "success", autoDismiss: true }
                        );
                    }
                })
                .catch((error) => {
                    captureException(error);
                });
        } else {
            setNewMsgStep("2");
        }
    };

    const updateMoveAlbumList = (e) => {
        // moveAlbumList and setMoveAlbumList
        const get_val = e.target.value;

        if (e.target.checked) {
            setMoveAlbumList([...moveAlbumList, { get_val }]);
        } else {
            const new_arr = moveAlbumList.filter(
                (element) => element.get_val != get_val
            );
            setMoveAlbumList(new_arr);
        }
    };

    const handleFavourite = () => {
        const formData = new FormData();
        const puId = localStorage.getItem("loggedin_user");
        formData.append("pu_id", puId);
        formData.append("follower_id", active);

        axios({
            method: "post",
            url: `/api/followers/favourite/${active}`,
            data: formData,
            headers: { "Content-Type": "multipart/form-data" },
        })
            .then((data) => {
                setFavourite(!favourite);
                const conversations = [...convList];
                const index = conversations.findIndex(
                    (c) => c.other_user_id == active
                );
                if (index >= 0) {
                    conversations[index].fave_user =
                        conversations[index].fave_user == "y" ? "n" : "y";
                    dispatch(updateConvList(conversations));
                }
            })
            .catch((error) => {
                captureException(error);
                if (error.response && error.response.status == 403) {
                    addToast("Action not allowed", {
                        appearance: "error",
                        autoDismiss: false,
                    });
                }
            });
    };

    const confirmSubsError = () => {
        setNewSubsError("");
        $("#last_hours").focus();
    };

    const handleStatsListInfoModal = () => {
        setStatsListInfoModalIsOpen(false);
    };

    const [fetchPpvListTrigger, setFetchPpvListTrigger] = useState("");
    const handleStatsModal = (stats_type = "", other_user_login = "") => {
        setStatsType(stats_type);
        setStatsLogin(other_user_login);

        if (stats_type == "single") {
            setPpvFilter("all_su");
        } else if (stats_type == "all") {
            setPpvFilter("top_earners");
        }

        if (!showStatsModal) {
            // only update when opening modal
            setFetchPpvListTrigger(stats_type);
        }

        setShowStatsModal(!showStatsModal);
    };

    const handleShowRenameFolder = () => {
        setShowRenameFolder(!showRenameFolder);
    };

    const handleMovetoFolder = () => {
        if (stashSelected.length > 0) {
            setMoveAlbumList([]);
            reloadAlbumList();
            setShowMoveFolder(!showMoveFolder);
            setActiveAlbum("");
        }
    };

    const handleCreateNewAlbum = () => {
        setShowCreateAlbum(!showCreateAlbum);
    };

    const handleAddtoAlbum = () => {
        if (moveAlbumList.length == 0) {
            return false;
        }

        const formData = new FormData();

        moveAlbumList.map((album_id) => {
            formData.append("album_id_list[]", album_id.get_val);
        });
        stashSelected.map((file, index) => {
            formData.append("media[]", file.media_id);
        });

        axios({
            method: "post",
            url: "/api/albums/update",
            data: formData,
        })
            .then((response) => {
                if (!onComposeMessage) {
                    setStashSelected([]);
                }

                setShowAlert(true);
                setHasConfirmation(false);

                const albumIds = moveAlbumList.map((album) =>
                    parseInt(album.get_val)
                );

                const albums = albumList
                    .map((album) => {
                        if (albumIds.includes(album.id)) {
                            return album.album_name;
                        }
                    })
                    .filter((album) => album);

                setModalBody(
                    `Media successfully added to ${albums.join(", ")} album${
                        albums.length > 1 ? "s" : ""
                    }`
                );
                handleMovetoFolder();
            })
            .catch((error) => {
                captureException(error);
            });
    };

    const [filesizeErrors, setFilesizeErrors] = useState([]);
    const [showUploadAlert, setShowUploadAlert] = useState(false);
    const [alertTitle, setAlertTitle] = useState(false);
    const [alertBody, setAlertBody] = useState("");
    const maxFileSize = 1610612736; // 1.5GB

    const onDrop = useCallback(
        (images, mediaOrAlbum, editAlbum, userRole, settings) => {
            if (images.length > parseInt(settings.max_stash_file_uploads)) {
                setAlertTitle("");
                setAlertBody(`
                <p>
                    Your attempt to upload ${
                        images.length
                    } media files all at once is not allowed.
                </p>
                <p>
                    You are permitted to upload up to ${
                        settings.max_stash_file_uploads || 25
                    } media files at a time from your device.
                </p>
            `);
                setShowUploadAlert(true);

                return;
            }

            let sumFileSize = 0;
            images.forEach((file) => {
                sumFileSize += file.size;
            });

            if (sumFileSize > maxFileSize) {
                setAlertTitle("");
                setAlertBody(`
                <p>The selected media size exceeds the ${bytesToSize(
                    maxFileSize
                )} amount that can be done in the one upload step.</p>
                <p>Please make a smaller selection of media that total less than <b>${bytesToSize(
                    maxFileSize
                )}</b> and try to upload again.</p>
            `);
                setShowUploadAlert(true);

                return;
            }

            setImages([...images]);
            const curr_images = images;
            const formData = new FormData();

            setProgressbar(0);
            setFileLoadingText("");

            if (userRole == ROLES.SU) {
                // separate upload process for SU
                // const files = e.target.files || e.dataTransfer.files;
                const clips = [];
                let i = 0;

                images.forEach((file) => {
                    formData.append("files[]", file);
                    clips[i] = file;
                    setAttach([...clips]);
                    i++;
                });

                setSending(true);

                formData.append(
                    "sender_id",
                    localStorage.getItem("loggedin_user")
                );

                setMessage("");
                setImages([]);
                setShowLoader(true);
                setIsUploading(true);

                axios({
                    method: "post",
                    url: "/api/stash-upload",
                    data: formData,
                    headers: { "Content-Type": "multipart/form-data" },
                })
                    .then((data) => {
                        // handle success
                        setShowLoader(false);
                        setStashSelected([data.data.media]);
                        reloadAlbumList();
                        setSending(false);
                        setIsUploading(false);
                    })
                    .catch((error) => {
                        setShowLoader(false);
                        captureException(error);
                        setSending(false);
                        setIsUploading(false);
                    });
            } else {
                images.forEach((file) => {
                    curr_images.push(file);
                    formData.append("files[]", file);
                });

                setSending(true);

                const images_upload = images;
                const config = {
                    headers: { "Content-Type": "multipart/form-data" },
                };
                const total_files = images.length;
                const uploaded = 0;

                formData.append(
                    "sender_id",
                    localStorage.getItem("loggedin_user")
                );

                if (mediaOrAlbum == "view_album") {
                    formData.append("edit_album", editAlbum);
                }

                setMessage("");
                setImages([]);
                setShowLoader(true);
                setIsUploading(true);

                axios({
                    method: "post",
                    url: "/api/stash-upload",
                    data: formData,
                    headers: { "Content-Type": "multipart/form-data" },
                    onUploadProgress: (progressEvent) => {
                        const loaded = parseInt(
                            Math.round(
                                (progressEvent.loaded / progressEvent.total) *
                                    100
                            )
                        );

                        setProgressbar(loaded);
                        if (loaded == 100) {
                            setFileLoadingText("Processing media...");
                        }
                    },
                })
                    .then((data) => {
                        if (editAlbum != "") {
                            reloadAlbumList();
                        }
                        setIsUploading(false);
                        setShowLoader(false);
                        setSending(false);
                    })
                    .catch((error) => {
                        setShowLoader(false);
                        captureException(error);

                        setIsUploading(false);
                        setShowLoader(false);

                        if (error.response && error.response.status === 422) {
                            let tmp = "";
                            Object.keys(error.response.data.errors).forEach(
                                (key) => {
                                    tmp += `${error.response.data.errors[key][0]}<br />`;
                                }
                            );

                            setAlertTitle("");
                            setAlertBody(tmp);
                            setShowUploadAlert(true);
                        }

                        setSending(false);
                    });
            }
        },
        []
    );

    useEffect(() => {
        if (filesizeErrors.length > 0) {
            let tmp = `<p>The media file you tried to upload is too big.  The maximum size is ${bytesToSize(
                maxFileSize
            )}</p><ul>`;
            filesizeErrors.forEach((error) => {
                tmp += `<li>Media file name: ${error.filename}</li>`;
            });
            tmp += "</ul><p>Tip: Try trimming your media and upload again.</p>";
            setAlertTitle("Media file is too big to upload");
            setAlertBody(tmp);
            setShowUploadAlert(true);
        }
    }, [filesizeErrors]);

    const customStyles = {
        content: {
            top: "50%",
            left: "50%",
            right: "auto",
            bottom: "auto",
            marginRight: "-50%",
            width: "40%",
            maxWidth: "600px",
            transform: "translate(-50%, -50%)",
        },
        overlay: {
            backgroundColor: "rgba(41, 48, 68, 0.7)",
            zIndex: "10000",
        },
    };

    const onDropRejected = useCallback((errors) => {
        const tmpErrors = [];
        errors.forEach((error) => {
            if (error.errors.find((e) => e.code === "file-too-large")) {
                tmpErrors.push({
                    filename: error.file.name,
                });
            }
        });
        if (tmpErrors.length > 0) {
            setFilesizeErrors(tmpErrors);
        }
    }, []);

    const { acceptedFiles, getRootProps, getInputProps, isDragActive } =
        useDropzone({
            onDropRejected,
            onDrop: (images) =>
                onDrop(
                    images,
                    mediaOrAlbum,
                    editAlbum,
                    userDetails.role,
                    settings
                ),
            maxSize: maxFileSize,
            accept: "image/jpeg, image/png, video/mp4, video/quicktime",
        });

    const getSettings = () => {
        const params = {
            only: "max_stash_file_uploads,min_ppv_price,max_ppv_price",
        };

        setSettings(params);
    };

    const [followerDetails, setFollowerDetails] = useState({});
    const [user, setUser] = useState({});
    const [usersNewMsg, setUsersNewMsg] = useState([]);

    const processIntent = async () => {
        setProcessingIntent(true);
        await axios
            .post("/api/transactions/ppv-pay", {
                payment_intent: searchParams.get("payment_intent"),
                payment_intent_client_secret: searchParams.get(
                    "payment_intent_client_secret"
                ),
                user_id: searchParams.get("user_id"),
                msg_id: searchParams.get("msg_id"),
            })
            .then((response) => {
                setProcessingIntent(false);
                setintentCompleted(true);

                // used when payment intent and needs to set sidebar for active user
                const index = convList.findIndex(
                    (conversation) =>
                        conversation.user_a == searchParams.get("user_id") ||
                        conversation.user_b == searchParams.get("user_id")
                );
                if (index >= 0) {
                    window.dispatchEvent(
                        new CustomEvent("sidebar/setactive", {
                            detail: {
                                conv: convList[index],
                            },
                        })
                    );
                    dispatch(setShowChatGallery(true));
                    dispatch(setChatGalleryActiveMessage(response.data.data));
                }
            })
            .catch((error) => {
                setProcessingIntent(false);
                if (error.response) {
                    if (error.response.status == 503) {
                        dispatchAlert(
                            error.response.data.message ||
                                "We are currently performing maintenance. Please try again later.",
                            "error"
                        );
                    }
                }

                if (error.response && error.response.status == 404) {
                    dispatchAlert("PPV is no longer available", "error");
                    return;
                }

                dispatchAlert("Invalid link provided", "error");
            });
    };

    const [disableBroadcastSendMessage, setDisableBroadcastSendMessage] =
        useState(true);

    useEffect(() => {
        if (
            stashSelected.length > 0 ||
            (broadcastMessage !== "" && stashSelected.length === 0)
        ) {
            setDisableBroadcastSendMessage(false);
        } else {
            setDisableBroadcastSendMessage(true);
        }

        if (stashSelected.length > 0 && showPrice && ppvPrice === "") {
            setDisableBroadcastSendMessage(true);
        }

        if (sending) {
            setDisableBroadcastSendMessage(true);
        }
    }, [
        sending,
        ppvPriceError,
        showPrice,
        ppvPrice,
        stashSelected,
        broadcastMessage,
    ]);

    const [disableSendMessage, setDisableSendMessage] = useState(false);
    useDidMountEffect(() => {
        if (active) {
            handlePresence();
            setFirstPageLoaded(false);
            setFavourite(false);
            updateMuteHere(false);
            updateMuteOtherHere(false);
            setpauseLoadMore(true);

            const formData = new FormData();
            formData.append("pu_id", localStorage.getItem("loggedin_user"));
            formData.append("follower_id", active);

            setShowMessages(false);

            axios({
                method: "post",
                url: `/api/followers/favourite-details/${active}`,
                data: formData,
                headers: { "Content-Type": "multipart/form-data" },
            })
                .then((data) => {
                    setUser(data.data.user_details);
                    setFollowerDetails(data.data.su_details);
                    setFollowStatus(data.data.follow_status.status);

                    if (data.data.follow_status.status == 2) {
                        if (
                            userDetails &&
                            userDetails.id == data.data.follow_status.pu
                        ) {
                            setChatPlaceholder(
                                "User is no longer subscribed to you"
                            );
                        } else {
                            setDisableSendMessage(true);
                            setChatPlaceholder("Your subscription has expired");
                        }
                    } else {
                        setDisableSendMessage(false);
                        setChatPlaceholder("Type your message");
                    }

                    if (
                        data.data.su_details &&
                        Object.keys(data.data.su_details).length > 0
                    ) {
                        if (data.data.su_details.favourites == 1) {
                            setFavourite(true);
                        }
                    }

                    if (data.data.blocked == "yes") updateMuteHere(true);
                    if (data.data.blocked_other == "yes") {
                        updateMuteOtherHere(true);
                    }
                })
                .catch((error) => {
                    captureException(error);
                });
        }

        return () => {
            setIsOnline(false);
        };
    }, [active]);

    const fetchRecentUsers = () => {
        axios
            .get("/api/recent-users", {
                params: {},
            })
            .then(({ data }) => {
                setUsersNewMsg([...data.data]);
            })
            .catch((error) => {
                captureException(error);
            });
    };

    useEffect(() => {
        setConvIndex(null);
        const tmp = uuidv4();
        setUuid(tmp);

        const randomStr = uuidv4();
        setBroadcastId(randomStr);

        getSettings();

        setUserDetails(JSON.parse(localStorage.getItem("user")));

        if (userInformation && userInformation.role === ROLES.PU) {
            getBlockedUsers();
        }

        fetchRecentUsers();

        if (location.state && location.state.open === "broadcast") {
            setMsgModalIsOpen(true);
            setSelectedFilter("user_lists");
            setBroadcastModal(true);
        }
    }, []);

    useDidMountEffect(() => {
        if (convList && convList.length > 0) {
            const isIntent =
                searchParams.has("payment_intent") &&
                searchParams.has("payment_intent_client_secret") &&
                searchParams.has("msg_id");
            if (isIntent && !processIntent) {
                processIntent();
            }
        }
    }, []);

    useDidMountEffect(() => {
        setAddMediaAlbum("");
        setMediaFiles([]);
        if (mediaOrAlbum === "view_album") {
            setLoadingStash(true);
            setIsAddingToAlbum(false);
        } else if (mediaOrAlbum === "album") {
            setLoadingStash(true);
            reloadAlbumList();
        } else if (mediaOrAlbum === "media") {
            setLoadingStash(true);
        }
    }, [mediaOrAlbum]);

    useDidMountEffect(() => {
        if (newMsgStep == 1) {
            // clear values when opening new message and reset to step 1
            setNewMessageSelect(0);
            setNewMsgChecked("");
            setNewMsgSendSelected([]);
            setNewMsgStep(1);
        }

        updateShowPrice(false);
        setImages([]);
        setStashSelected([]);
    }, [msgModalIsOpen]);

    const openModal = (msgType = "", from = "") => {
        setStashShow(true);

        if (msgType === "broadcast" || from === "chat") {
            setOnComposeMessage(true);
        }

        if (msgType === "broadcast") {
            setOpenModalBroadcast(true);
        }
    };

    const closeModal = (isAdd = "") => {
        setStashFilter("all");
        setIsOpen(false);
        setStashModal(false);
        setActiveAlbum("");
        setStashSidebar(false);

        if (isAdd == "add") {
            setTmpStashSelection([]);
        }

        if (isAdd != "add") {
            let tmp = [...stashSelected];
            tmp = tmp.filter((t) => tmpStashSelection.indexOf(t.media_id) < 0);
            setStashSelected([...tmp]);
            setTmpStashSelection([]);
        }

        if (openModalBroadcast) {
            setOpenModalBroadcast(false);
        }

        setBroadcastProgress(0);
    };

    const closeNewMsg = () => {
        resetBroadcastForm();
        setMsgModalIsOpen(false);
        setStashSelected([]);
        setBroadcastModal(false);
        setNewMsgStep("1");
        setSelectedFilter("");
        setNewMsgSendSelected([]);
        dispatch(setTempSelected([]));
        setNewMsgChecked("");
        clearLocationState();
    };

    const getExcludeOptions = () => {
        axios
            .get("/api/fetchConvs", {
                params: {
                    all: true,
                    exclude: true,
                },
            })
            .then((response) => {
                setExcludeList(response.data);
            })
            .catch((error) => {
                captureException(error);
            });
    };

    const newMsgSelectUser = (other_name, other_id) => {
        const exist = newMsgSendSelected.find((exist) => exist.id == other_id);

        if (!exist) {
            setNewMsgSendSelected([
                ...newMsgSendSelected,
                { name: other_name, id: other_id },
            ]);
        }
    };

    const updateAlbumName = () => {
        const formData = new FormData();
        formData.append("album_id", confirmAlbumID);
        formData.append("album_name", renameAlbum);

        axios({
            method: "post",
            url: "/api/albums/update",
            data: formData,
        })
            .then((response) => {
                setConfirmAlbumID("");
                setMediaOrAlbum("album");
                setAlbumName("");
                reloadAlbumList();
                setShowAlert(true);
                setHasConfirmation(false);
                setModalBody("The album name is updated");
            })
            .catch((error) => {
                captureException(error);
            });
    };

    const deleteAlbum = () => {
        const formData = new FormData();
        formData.append("album_id", confirmAlbumID);

        axios({
            method: "post",
            url: `/api/albums/delete/${confirmAlbumID}`,
            data: formData,
        })
            .then((response) => {
                // handle success
                setShowAlert(true);
                setHasConfirmation(false);

                const deletedAlbum = albumList.find(
                    (album) => confirmAlbumID == album.id
                );

                setModalBody(
                    `Album ${deletedAlbum.album_name || ""} has been deleted`
                );
                setConfirmAlbumID("");
                setMediaOrAlbum("album");
                reloadAlbumList();
            })
            .catch((error) => {
                captureException(error);
            });
    };

    const addSelectStash = (media_id, thumb_path, stashMedia) => {
        if (stashSelected.find((element) => element.media_id == media_id)) {
            const new_arr = stashSelected.filter(
                (element) => element.media_id != media_id
            );
            setStashSelected(new_arr);
        } else {
            const tmp = [...tmpStashSelection];
            tmp.push(media_id);
            setTmpStashSelection([...tmp]);
            const newMedia = {
                media_id,
                thumb_path,
                type: stashMedia.type,
                file_path: stashMedia.file_path,
                large_path: stashMedia.large_path,
            };
            setStashSelected([...stashSelected, newMedia]);
        }
    };

    const saveNewAlbum = () => {
        if (albumName == "") {
            // alert('Please input album name.');
            setShowAlert(true);
            setModalBody("Please input album name.");
        } else {
            setShowLoader(true);

            const formData = new FormData();
            formData.append("album_name", albumName);

            stashSelected.map((file, index) => {
                formData.append("media[]", file.media_id);
            });

            axios({
                method: "post",
                url: "/api/albums/",
                data: formData,
            })
                .then((response) => {
                    // handle success
                    setShowAlert(true);
                    setShowLoader(false);
                    setAlbumName("");
                    setStashSelected([]);
                    setModalBody("Successfully created an album");
                    setMediaOrAlbum("album");
                    // alert('Album Saved.');
                })
                .catch((error) => {
                    captureException(error);
                });
        }
    };

    const [mediaFilesToGetInformation, setMediaFilesToGetInformation] =
        useState([]);
    const [tmpLastMessage, setTmpLastMessage] = useState({});
    const [lastMessageDone, setLastMessageDone] = useState(false);
    const getLatestMessage = async (medias) => {
        await axios
            .get("/api/medias/latest-message", {
                params: {
                    media_ids: mediaFilesToGetInformation,
                },
            })
            .then((response) => {
                setLastMessageDone(true);
                setTmpLastMessage(response.data);
            })
            .catch((error) => {
                console.error({ error });
            });
    };

    const [tmpStashMediaInformation, setTmpStashMediaInformation] = useState(
        {}
    );
    const [mediaInfDone, setMediaInfDone] = useState(false);
    const getStashMediaInformation = async () => {
        let otherUserId = "";
        if (convList) {
            const loggedInUser = localStorage.getItem("loggedin_user");
            const activeConversation = convList[convIndex];
            if (
                activeConversation &&
                Object.keys(activeConversation).length > 0 &&
                activeConversation.user_a == loggedInUser
            ) {
                otherUserId = activeConversation.user_b;
            }

            if (
                activeConversation &&
                Object.keys(activeConversation).length > 0 &&
                activeConversation.user_b == loggedInUser
            ) {
                otherUserId = activeConversation.user_a;
            }
        }

        await axios
            .get("/api/medias/message-information", {
                params: {
                    media_ids: mediaFilesToGetInformation,
                    sidebar: stashSidebar || broadcastModal,
                    other_user: otherUserId,
                },
            })
            .then((response) => {
                setMediaInfDone(true);
                setTmpStashMediaInformation(response.data);
                // Reset media to get information
                setMediaFilesToGetInformation([]);
            })
            .catch((error) => {
                console.error({ error });
            });
    };

    useDidMountEffect(() => {
        if (mediaInfDone && lastMessageDone) {
            setLastMessageDone(false);
            setMediaInfDone(false);

            const tmp = [...mediaFiles];
            if (tmpLastMessage.length > 0) {
                for (let i = 0; i < tmpLastMessage.length; i++) {
                    // index of response from existing media files
                    const index = mediaFiles.findIndex(
                        (mediaFile) =>
                            mediaFile.media_id == tmpLastMessage[i].media_id
                    );
                    if (index >= 0) {
                        tmp[index].latest_message = tmpLastMessage[i].messages;
                    }
                }
            }

            // loop
            if (tmpStashMediaInformation.length > 0) {
                for (let i = 0; i < tmpStashMediaInformation.length; i++) {
                    // index of response from existing media files
                    const index = mediaFiles.findIndex(
                        (mediaFile) =>
                            mediaFile.media_id ==
                            tmpStashMediaInformation[i].media_id
                    );
                    if (index >= 0) {
                        tmp[index].messages =
                            tmpStashMediaInformation[i].latest_message;
                    }
                }
            }

            setMediaFiles([...tmp]);
        }
    }, [tmpStashMediaInformation, tmpLastMessage]);

    useEffect(() => {
        if (mediaFilesToGetInformation.length > 0) {
            getLatestMessage();
            getStashMediaInformation();
        }
    }, [mediaFilesToGetInformation]);

    const addStash = () => {
        closeModal("add");
    };

    const stashOpenVideo = (media) => {
        const video_src = media.file_path;
        const aspectRatio = checkAspectRatio(media.aspect_ratio);
        setContainerClass(aspectRatio);
        updateshowVideoModal(true);
        updateImageModalSrc(video_src);
    };

    const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);

    const removeStash = () => {
        if (stashSelected.length > 0) {
            setShowLoader(true);

            const formData = new FormData();
            formData.append("album_id", editAlbum);

            stashSelected.map((file, index) => {
                formData.append("media[]", file.media_id);
            });

            if (mediaOrAlbum == "view_album") {
                axios({
                    method: "post",
                    url: "/api/albums/remove-from-album",
                    data: formData,
                })
                    .then((response) => {
                        if (editAlbum) {
                            reloadAlbumList();
                        }
                        setShowAlert(true);
                        setShowLoader(false);
                        const album = albumList.find(
                            (album) => album.id == editAlbum
                        );
                        setModalBody(
                            `Media removed from ${
                                album.album_name || "this"
                            } album only`
                        );
                        setStashSelected([]);
                        setShowDeleteConfirm(false);
                    })
                    .catch((error) => {
                        captureException(error);
                        setShowDeleteConfirm(false);
                    });
            } else {
                axios({
                    method: "post",
                    url: "/api/medias/delete",
                    data: formData,
                })
                    .then((response) => {
                        setShowDeleteConfirm(false);
                        if (stashFilter == "image" || stashFilter == "video") {
                            // do nothing
                        } else {
                            setShowLoader(false);

                            addToast(
                                "Selected media has been removed from stash",
                                {
                                    appearance: "success",
                                    autoDismiss: true,
                                    autoDismissTimeout: 4000,
                                }
                            );
                            setStashSelected([]);
                        }
                    })
                    .catch((error) => {
                        captureException(error);
                        setShowDeleteConfirm(false);
                    });
            }
        } else {
            setShowAlert(true);
            setHasConfirmation(false);
            setModalBody("Please select at least one media file.");
        }
    };

    const reloadAlbumList = () => {
        axios({
            method: "get",
            url: "/api/albums",
        })
            .then((response) => {
                setAlbumList(response.data);
            })
            .catch((error) => {
                captureException(error);
            });
    };

    useEffect(() => {
        if (albumList && albumList.length > 0) {
            const data = albumList.find((album) => album.id == activeAlbum);
            if (data) {
                setActiveEditAlbumObject(data);
            }
        }
    }, [albumList]);

    const scrollToBottom = () => {
        $(".messenger-main").scrollTop(
            $(".messenger-main").prop("scrollHeight")
        );
    };

    const uploadFiles = () => {
        const images_upload = images;
        const config = { headers: { "Content-Type": "multipart/form-data" } };
        const total_files = images.length;
        const uploaded = 0;

        // setUploading(true);

        images_upload.map((image) => {
            const formData = new FormData();
            formData.append("file", image);

            axios({
                method: "post",
                url: "/api/uploadFiles",
                data: formData,
                headers: { "Content-Type": "multipart/form-data" },
            })
                .then((response) => {
                    // handle success
                })
                .catch((error) => {
                    captureException(error);
                });
        });
    };

    const removeItem = (ind = -1) => {
        const set = files.filter((i, k) => k !== ind);
        setAttach([...set]);
    };

    const handleKeySend = (event) => {
        if (event.shiftKey && isDesktop) {
            if (event.key === "Enter") {
                let tmp = JSON.parse(JSON.stringify(broadcastMessage));
                tmp += "\n";

                setBroadcastMessage(tmp);

                return;
            }
        }

        if ((event.key === "Enter" || event.keyCode === 13) && isDesktop) {
            event.preventDefault();
            submitBroadcast();
        }
    };

    const onChangeInputBroadcastStr = (ecaption) => {
        setBroadcastMessage(ecaption);
    };

    const onChangeAlbumName = (e) => {
        setAlbumName(e.target.value);
    };

    const onChangePrice = (e) => {
        const price = e.target.value.toString().replace(/^0+/, "");
        setPpvPrice(price);
    };

    useEffect(() => {
        if (ppvPrice > 0) {
            let price = ppvPrice.toString().replace(/^0+/, "");
            price = price.replace(/[\.\%]/g, (match, offset, all) =>
                match === "." ? (all.indexOf(".") === offset ? "." : "") : ""
            );
            setPpvPrice(toFixedTrunc(price, 2));
        }
    }, [ppvPrice]);

    const onChangeRenameAlbum = (e) => {
        setRenameAlbum(e.target.value);
    };

    const togglePriceInput = () => {
        updateShowPrice(!showPrice);
    };

    const changeMute = (e) => {
        updateMuteHere(!muteVal);

        const formData = new FormData();
        formData.append("blocker_id", localStorage.getItem("loggedin_user"));
        formData.append("blocked_id", active);

        // if(!isMute) {
        if (!muteVal) {
            formData.append("mute_action", "yes");
        } else {
            formData.append("mute_action", "no");
        }

        axios({
            method: "post",
            url: `/api/followers/block/${active}`,
            data: formData,
            headers: { "Content-Type": "multipart/form-data" },
        })
            .then((data) => {
                // setShowLoader(false);
            })
            .catch((error) => {
                captureException(error);
            });
    };

    const resetBroadcastForm = () => {
        setSending(false);
        setPpvPriceError("");
        updateShowPrice(false);
        setPpvPrice("");
        setStashSelected([]);
        setBroadcastMessage("");
        updateBroadcastMsg("");
    };

    const submitBroadcast = () => {
        if (sending || disableBroadcastSendMessage) {
            return false;
        }

        if (stashSelected.length == 0 && ppvPrice > 0) {
            setAlertBody("Please select at least one attachment");
            setShowUploadAlert(true);
            return false;
        }

        if (stashSelected.length == 0 && broadcastMessage.trim().length <= 0) {
            setAlertBody(
                "Please select at least one attachment or add a broadcast message"
            );
            setShowUploadAlert(true);
            return false;
        }

        const hasFreePreview =
            freePreview && Object.keys(freePreview).length > 0;
        const numStashSelected = stashSelected.length;
        if (hasFreePreview && numStashSelected === 1) {
            setAlertBody("Free preview can only be used with multiple media");
            setShowUploadAlert(true);
            return false;
        }

        const myId = parseInt(localStorage.getItem("loggedin_user"));
        const formData = new FormData();
        formData.append("message", broadcastMessage);

        if (showPrice) {
            if (parseFloat(ppvPrice) < minPpvPrice) {
                setPpvPriceError(true);
                return false;
            }
            if (parseFloat(ppvPrice) > maxPpvPrice) {
                setPpvPriceError(true);
                return false;
            }
        }

        setSending(true);
        setShowLoader(true);
        if (ppvPrice > 0) {
            formData.append("ppv_price", ppvPrice);

            if (isDiscounted) {
                formData.append("promo_price", promoPrice);
                formData.append("expiry_date", JSON.stringify(expiry));
            }
        }

        formData.append("sender_id", myId);
        formData.append("broadcast_id", broadcastId);

        if (!newMsgChecked && isResend) {
            formData.append("broadcast_type", "resend");
        } else {
            formData.append("broadcast_type", newMsgChecked);
        }

        if (newMsgChecked == "new") {
            formData.append("new_subs_limit", lastSubsParent);
            formData.append("new_subs_pastHours", pastHoursParent);
        }

        stashSelected.map((file, index) => {
            formData.append("media[]", file.media_id);
        });

        newMsgSendSelected.map((k, i) => {
            formData.append("broadcast_list[]", k.id);
        });

        if (newMsgChecked === "subs_range") {
            const from = moment(rangeDateFromParent).format("YYYY-MM-DD");
            const to = moment(rangeDateToParent).format("YYYY-MM-DD");
            formData.append("range_id_from", rangeIdFromParent);
            formData.append("range_id_to", rangeIdToParent);
            formData.append("range_date_from", from);
            formData.append("range_date_to", to);
        }

        if (newMsgChecked === "user_lists") {
            formData.append(
                "list_ids",
                messageUserListsFilterRdx.map((uList) => uList.id)
            );
        }

        formData.append(
            "except",
            excluded.length > 0 ? excluded.map((e) => e.id).join(",") : ""
        );

        if (freePreview && Object.keys(freePreview).length > 0) {
            formData.append("free_preview", freePreview.media_id);
        }

        formData.append("send_by", sendBy);

        if (userInformation.role == ROLES.ADMIN) {
            formData.append("send_email", sendEmail);
        }

        setIsSendingBroadcast(true);
        updateBroadcastIndicator(true);

        const stashPayload = {
            stashSelected: [],
            tabSelected: "media",
            albumAction: "",
            stashSidebar: false,
            busy: false,
        };

        axios({
            method: "post",
            url: "/api/broadcast-message",
            data: formData,
            headers: { "Content-Type": "multipart/form-data" },
        })
            .then((data) => {
                setIsResend(false);
                setIsSendingBroadcast(false);

                if (refreshConvList) {
                    setRefreshConvList(false); // refresh conversation list
                } else {
                    setRefreshConvList(true);
                }

                setLoadMessageTrigger(
                    (loadMessageTrigger) => (loadMessageTrigger += 1)
                );
                updateBroadcastIndicator(false);

                dispatch(resetMessageUserListsFilter());
            })
            .catch((error) => {
                setIsSendingBroadcast(false);
                captureException(error);
                setSending(false);
                setShowLoader(false);
                updateBroadcastIndicator(false);
                if (error.response && error.response.status == 422) {
                    Object.keys(error.response.data.errors).forEach((key) => {
                        if (key == "ppv_price") {
                            setPpvPriceError(true);
                        }
                    });
                } else {
                    addToast("Message not sent.", {
                        appearance: "error",
                        autoDismiss: false,
                    });
                }
            });

        setTimeout(() => {
            resetBroadcastForm();
            setShowLoader(false);
            setMsgModalIsOpen(false);
            closeModal();
            setBroadcastModal(false);
            closeNewMsg();
            setIsOpen(false);
            setNewMsgStep("1"); // reset to step 1
            setBroadcastMessage("");
            setImages([]);
            setStashSelected([]);
            setPpvPriceError(false);
            setActive(active);
            updateShowPrice(false);
            setNewMsgSendSelected([]); // clear user selected for broadcast
            setAttach([]);
            setNewMsgChecked(""); // uncheck choices in send broadcast
            updateBroadcastMsg("");
            setSending(false);
            setExcluded([]);
            setStash(stashPayload);
        }, 800);
    };

    const openModalImage = (media) => {
        const img = media.large_path ? media.large_path : media.file_path;
        const aspectRatio = checkAspectRatio(media.aspect_ratio);
        setContainerClass(aspectRatio);
        updateShowImageModal(true);
        updateImageModalSrc(img);
    };

    const [minPpvPrice, setMinPpvPrice] = useState(DefaultPpvPrice.minAmount);
    const [maxPpvPrice, setMaxPpvPrice] = useState(DefaultPpvPrice.maxAmount);

    useEffect(() => {
        if (settings && Object.keys(settings).length > 0) {
            setMinPpvPrice(parseFloat(settings.min_ppv_price));
            setMaxPpvPrice(parseFloat(settings.max_ppv_price));
        }
    }, [settings]);

    useEffect(() => {
        setPpvPrice("");
        setPpvPriceError(false);
    }, [activeConv]);

    const [helpText, setHelpText] = useState(
        `Min ${currency(minPpvPrice).format({ precision: 2 })} USD`
    );
    useEffect(() => {
        if (ppvPrice != "") {
            if (ppvPrice < minPpvPrice) {
                setPpvPriceError(true);
                setHelpText(
                    `Min ${currency(minPpvPrice).format({ precision: 2 })} USD`
                );
            }

            if (ppvPrice > minPpvPrice) {
                setPpvPriceError(true);
                setHelpText(
                    `Max ${currency(maxPpvPrice).format({ precision: 2 })} USD`
                );
            }

            if (ppvPrice >= minPpvPrice && ppvPrice <= maxPpvPrice) {
                setPpvPriceError(false);
                setHelpText(
                    `Min ${currency(minPpvPrice).format({ precision: 2 })} USD`
                );
            }
        } else {
            setPpvPriceError(false);
            setHelpText(
                `Min ${currency(minPpvPrice).format({ precision: 2 })} USD`
            );
        }
    }, [ppvPrice, minPpvPrice, maxPpvPrice]);

    useEffect(() => {
        if (stashModal) {
            openModal();
        }
    }, [stashModal]);

    const handleSelectAlbum = (k) => {
        setEditAlbum(k.id);
        setActiveAlbum(k.id);
    };

    const [activeEditAlbumObject, setActiveEditAlbumObject] = useState({});

    const handleBackToSidebar = () => {
        if (showChatGallery) {
            dispatch(setShowChatGallery(false));
            dispatch(setChatGalleryActiveMessage([]));
            dispatch(setChatGalleryMessages([]));
            return;
        }
        setShowMobileChat(false);
        updateActiveConv(null);
        setConvIndex(null);
    };

    useDidMountEffect(() => {
        setMediaSent([]);
        setMediaSold([]);
        setMediaFiles([]);
    }, [stashSidebar]);

    useDidMountEffect(() => {
        if (convList.length > 0) {
            setMediaFiles([]);
            setMediaSent([]);
            setMediaSold([]);
        }
    }, [convIndex]);

    useDidMountEffect(() => {
        if (broadcastModal) {
            setMediaFiles([]);
            setMediaSent([]);
            setMediaSold([]);
        }
    }, [broadcastModal]);

    const [excluded, setExcluded] = useState([]);
    useEffect(() => {
        if (msgModalIsOpen) {
            getExcludeOptions();
        }
    }, [msgModalIsOpen]);

    const [deletedMessagePrice, setDeletedMessagePrice] = useState({});
    const [activeStashItem, setActiveStashItem] = useState({});
    useEffect(() => {
        if (
            deletedMessagePrice &&
            Object.keys(deletedMessagePrice).length > 0
        ) {
            const tmpFiles = [...mediaFiles];
            const index = tmpFiles.findIndex(
                (file) => file.media_id === activeStashItem.media_id
            );
            if (index >= 0) {
                if (
                    tmpFiles[index].messages &&
                    tmpFiles[index].messages.length > 0
                ) {
                    tmpFiles[index].messages[0] = deletedMessagePrice;
                } else {
                    tmpFiles[index].messages = [deletedMessagePrice];
                }
                tmpFiles[index].latest_price = deletedMessagePrice.price;
            }

            setMediaFiles(tmpFiles);
        }
    }, [deletedMessagePrice]);

    const [newMessageObject, setNewMessageObject] = useState({});
    useDidMountEffect(() => {
        // new message is triggered when submitted
        setNewMessageObject({
            message: caption,
            uuid,
            medias: stashSelected,
            price: ppvPrice,
            msg_type: ppvPrice > 0 ? 1 : 2,
            sender_id: userInformation.id,
            rec_id: localStorage.getItem("other_user"),
        });
    }, [newMessage]);

    const [isResend, setIsResend] = useState(false);
    const [resending, setResending] = useState(false);
    const handleResend = async () => {
        dispatch(setTempSelected([]));

        setResending(true);

        await axios
            .get("/api/messages/resend", {
                params: {
                    media_ids: stashSelected.map((stash) => stash.media_id),
                },
            })
            .then((response) => {
                setResending(false);
                if (
                    response.data.receivers &&
                    response.data.receivers.length > 0
                ) {
                    setStashShow(false);
                    history.push({
                        pathname: "/messages/newmessage",
                        state: {
                            isResend: true,
                            response: response.data,
                        },
                    });
                } else {
                    dispatchAlert(
                        "All followers have purchased the media",
                        "info"
                    );
                }

                //   setStashShow(false);
                //   setIsResend(true);
                //   // setMsgModalIsOpen(true);
                //   updateShowPrice(true);
                //   setBroadcastModal(true);
                //   setNewMsgStep('2');

                //   const sendList = response.data.receivers.map((receiver) => ({ name: receiver.login, id: receiver.id }));

                //   setNewMsgSendSelected(sendList);
                //   setUserCount(sendList.length);
                //   setPpvPrice(response.data.message.price);
                //   updateBroadcastMsg(response.data.message.message);
                //   setBroadcastMessage(response.data.message.message);
                //   setStashSelected(response.data.message.medias);
                //   setTmpStashSelection(response.data.message.medias);
                //   setStashSidebar(false);

                //   // setting free preview
                //   // @TODO: update this when we allow multiple free previews
                //   const resultMedia = response.data.message.medias;
                //   const resultFreeMedia = resultMedia && resultMedia.length > 0
                //     ? resultMedia.find(media => media.free_preview)
                //     : {};
                //   if (resultFreeMedia && Object.keys(resultFreeMedia).length > 0) {
                //     setFreePreview(resultFreeMedia);
                //   }

                // } else {
                //   dispatchAlert('All followers have purchased the media', 'info');
                // }
            })
            .catch((error) => {
                console.error({ error });
                if (error.response && error.response.status === 404) {
                    dispatchAlert(
                        "Media was not used in a broadcast PPV",
                        "error"
                    );
                } else {
                    dispatchAlert("Failed to resend the message", "error");
                }

                setResending(false);
            });
    };

    const [freePreview, setFreePreview] = useState({});
    const [reshuffled, setReshuffled] = useState(0);
    const handleSelectFreePreview = useCallback(
        (media) => {
            if (Object.keys(media).length > 0) {
                if (media.media_id == freePreview.media_id) {
                    setFreePreview({});
                } else {
                    setFreePreview(media);
                    const index = stashSelected.findIndex(
                        (s) => s.media_id == media.media_id
                    );
                    const tmp = [...stashSelected];
                    if (index >= 0) {
                        const selected = tmp.splice(index, 1);
                        tmp.unshift(selected[0]);
                    }

                    setStashSelected(tmp);
                }
            } else {
                setFreePreview({});
            }
        },
        [stashSelected, freePreview]
    );

    useDidMountEffect(() => {
        setFreePreview(stashSelected[0]);
    }, [reshuffled]);

    const [deleteMessage, setDeleteMessage] = useState("");
    useDidMountEffect(() => {
        if (activeAlbum) {
            const album = albumList.find((album) => album.id == activeAlbum);

            if (album) {
                setDeleteMessage(
                    `Remove file from folder ${album.album_name}? File will not be deleted from stash.`
                );
            } else {
                setDeleteMessage(
                    "Remove file from folder? File will not be deleted from stash."
                );
            }
        } else {
            setDeleteMessage("Remove the media file from Stash?");
        }
    }, [activeAlbum]);

    const openPersonalNote = async (e) => {
        e.preventDefault();

        await axios
            .post("/api/subscriber-note", {
                su_id: user.id,
            })
            .then((response) => {
                if (response.data.success) {
                    dispatch(setActivePersonalNote(response.data.notes));
                    dispatch(setPersonalNoteIsOpen(true));
                }
            })
            .catch((error) => {
                console.log("cannot open personal notes");
            });
    };

    const handleOpenChatGallery = () => {
        dispatch(setShowChatGallery(true));
        dispatch(setChatGallerySource("individual"));
    };

    const handleShowChatGallery = () => {
        return showChatGallery && chatGallerySource !== "sidebar";
    };

    const setChatMessageHeader = () =>
        [1, 2].includes(userInformation.role)
            ? "messenger-header curent-chat-user"
            : "messenger-header curent-chat-user su-user";

    const [userInfoWidth, setUserInfoWidth] = useState(0);
    const [actionButtonsWidth, setActionButtonsWidth] = useState(0);
    const [messengerHeaderWidth, setMessengerHeaderWidth] = useState(0);
    const [returnButtonWidth, setReturnButtonWidth] = useState(0);

    const messengerHeaderRef = useCallback((node) => {
        if (node) {
            if (node.offsetWidth !== messengerHeaderWidth) {
                setMessengerHeaderWidth(node.offsetWidth);
            }
        }
    });

    const actionButtonsRef = useCallback((node) => {
        if (node) {
            if (node.offsetWidth !== actionButtonsWidth) {
                setActionButtonsWidth(node.offsetWidth);
            }
        }
    });

    const returnButtonRef = useCallback(
        (node) => {
            if (node) {
                setReturnButtonWidth(node.offsetWidth);
            }
        },
        [active]
    );

    const userInfoRef = useCallback(
        (node) => {
            if (node) {
                if (messengerHeaderWidth && actionButtonsWidth) {
                    if (messengerHeaderWidth > actionButtonsWidth) {
                        let width = messengerHeaderWidth - actionButtonsWidth;
                        width =
                            width -
                            (returnButtonWidth ? returnButtonWidth + 30 : 0);

                        setUserInfoWidth(width - 30);
                    }
                }
            }
        },
        [active, actionButtonsWidth, messengerHeaderWidth, returnButtonWidth]
    );

    useEffect(() => {
        const handleResize = () => {
            setMessengerHeaderWidth(messengerHeaderWidth);
        };

        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    const [isCurrentlyTyping, setIsCurrentlyTyping] = useState(false);
    const [channelName, setChannelName] = useState(null);
    const [echoChannel, setEchoChannel] = useState(null);
    const [echoEventName, setEchoEventName] = useState(null);
    const [prevConvo, setPrevConvo] = useState(null);
    const [indicatorTimeout, setIndicatorTimeout] = useState(null);

    useEffect(() => {
        if (activeConv) {
            if (activeConv != prevConvo) {
                if (prevConvo && echoChannel) {
                    echoChannel.leave(`privaposts-dm-typing-${prevConvo}`);
                }

                setPrevConvo(activeConv);
            }

            const typingEvent = "is-typing";
            const cName = `privaposts-dm-typing-${activeConv}`;
            const clearIndicatorInterval = 5000;
            let clearTimer;
            const token = localStorage.getItem("loggedin_access_token");
            const currentUser = JSON.parse(localStorage.getItem("user"));

            Pusher.logToConsole = process.env.MIX_APP_ENV !== "production";
            const echoInit = new Echo({
                broadcaster: "pusher",
                key: process.env.MIX_PUSHER_APP_KEY,
                cluster: process.env.MIX_PUSHER_APP_CLUSTER,
                authEndpoint: "/broadcasting/auth",
                auth: {
                    headers: {
                        Accept: "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                },
            });

            setEchoChannel(echoInit);
            setChannelName(cName);
            setEchoEventName(typingEvent);

            echoInit.private(cName).listenForWhisper(typingEvent, (event) => {
                if (event.name === currentUser.login) {
                    setIsCurrentlyTyping(true);
                    const element =
                        document.getElementsByClassName("messenger-main")[0];

                    if (
                        element.scrollHeight -
                            element.clientHeight -
                            $(".messenger-main").scrollTop() <=
                        71
                    ) {
                        $(".messenger-main").scrollTop(
                            $(".messenger-main").prop("scrollHeight")
                        );
                    }

                    clearTimeout(clearTimer);
                    clearTimeout(indicatorTimeout);

                    clearTimer = setTimeout(() => {
                        setIsCurrentlyTyping(false);
                    }, clearIndicatorInterval);

                    setIndicatorTimeout(clearTimer);
                }
            });

            echoInit
                .private(cName)
                .listenForWhisper("message-sent", (event) => {
                    if (event.name === currentUser.login) {
                        clearTimeout(indicatorTimeout);
                        setIsCurrentlyTyping(false);
                    }
                });
        }
    }, [activeConv]);

    const [canRequest, setCanRequest] = useState(true);
    const [clearRequestInterval, setClearRequestInterval] = useState(300);
    useEffect(() => {
        if (channelName && echoChannel && echoEventName && caption) {
            if (canRequest) {
                echoChannel.private(`${channelName}`).whisper(echoEventName, {
                    name: user.login,
                    channel: channelName,
                });
                setCanRequest(false);

                const trigger = setTimeout(() => {
                    setCanRequest(true);
                }, clearRequestInterval);
            }
        }
    }, [caption]);

    useEffect(() => {
        if (echoChannel) {
            echoChannel.private(`${channelName}`).whisper("message-sent", {
                name: user.login,
                channel: channelName,
            });
        }
    }, [newMessage]);

    const viewportWidth = window.innerWidth;
    const DEFAULT_CHAT_MESSAGE_MARGIN_TOP = viewportWidth > 767 ? 48 : 68;
    const DEFAULT_TEXT_AREA_HEIGHT = 133;
    const [chatMessageMarginTop, setChatMessageMarginTop] = useState(
        DEFAULT_CHAT_MESSAGE_MARGIN_TOP
    );
    const textAreaRef = useCallback(
        (node) => {
            if (node) {
                if (
                    node.offsetHeight === 0 ||
                    node.offsetHeight === 10 ||
                    DEFAULT_TEXT_AREA_HEIGHT === node.offsetHeight
                ) {
                    setChatMessageMarginTop(DEFAULT_CHAT_MESSAGE_MARGIN_TOP);
                } else {
                    setChatMessageMarginTop(
                        DEFAULT_TEXT_AREA_HEIGHT +
                            DEFAULT_CHAT_MESSAGE_MARGIN_TOP -
                            node.offsetHeight
                    );
                }
            }
        },
        [caption, newMessage, stashSelected.length, showPrice]
    );

    const forceStopTypingIndicator = useCallback(() => {
        if (isCurrentlyTyping) {
            clearTimeout(indicatorTimeout);
            setIsCurrentlyTyping(false);
        }
    }, [isCurrentlyTyping]);

    const handlePresence = () => {
        if (
            presence &&
            presence.length > 0 &&
            presence.includes(parseInt(active))
        ) {
            setIsOnline(true);
        } else {
            setIsOnline(false);
        }
    };

    useEffect(() => {
        handlePresence();
    }, [presence]);

    const onStashClose = () => {
        if (onComposeMessage) {
            setOnComposeMessage(false);
        }
    };

    const setShowPrice = (status) => {
        updateShowPrice(status);
    };

    const handleEndTime = (postID) => {
        console.log("🚀 ~ handleEndTime ~ postID:", postID);
    };

    const resetExpiry = () => {
        setExpiry({
            days: 0,
            hours: 0,
            minutes: 0,
        });
    };

    const resetPrevExpiry = () => {
        setPrevExpiry({
            days: 0,
            hours: 0,
            minutes: 0,
        });
    };

    const resetPriceModal = () => {
        setPpvPrice("");
        setPromoPrice("");
        resetExpiry();
        setIsDiscounted(false);
        setPrevPpvPrice("");
        setPrevPromoPrice("");
        resetPrevExpiry();
        setPrevIsDiscounted(false);
    };

    useEffect(() => {
        console.log("::muteOtherVal", muteOtherVal);
    }, [muteOtherVal]);

    const handlePriceInformationClose = () => {
        setPpvPrice("");
        setPromoPrice("");
        // setExpiryDate(moment().add(1, 'hours'));
        setIsDiscounted(false);
        setPrevPpvPrice("");
        setPrevPromoPrice("");
        // setPrevExpiryDate(moment().add(1, 'hours'));
        setPrevIsDiscounted(false);
        updateShowPrice(false);
    };

    const handlePriceModalClose = (param = "") => {
        if (param) {
            if (param === "ok") {
                setPrevPpvPrice(ppvPrice);
                setPrevPromoPrice(promoPrice);
                setPrevExpiry(expiry);
                setPrevIsDiscounted(isDiscounted);
            } else if (param === "cancel") {
                if (prevPpvPrice) {
                    setPpvPrice(prevPpvPrice);
                    setPromoPrice(prevPromoPrice);
                    setExpiry(prevExpiry);
                    setIsDiscounted(prevIsDiscounted);
                } else {
                    resetPriceModal();
                }
            }
        } else {
            if (!ppvPrice) {
                setIsDiscounted(false);
                setPrevPpvPrice("");
                setPrevPromoPrice("");
                resetPrevExpiry();
                setPrevIsDiscounted(false);
            }
        }

        updateShowPrice(false);
    };

    useEffect(() => {
        if (!ppvPrice || ppvPrice <= 0) {
            setPromoPrice("");
            setIsDiscounted(false);
        }
    }, [ppvPrice]);

    useEffect(() => {
        if (!promoPrice) {
            if (
                showPrice &&
                prevExpiry.days &&
                prevExpiry.hours &&
                prevExpiry.minutes
            ) {
                resetExpiry();
                resetPrevExpiry();
            } else {
                setIsDiscounted(false);
            }
        }

        if (showPrice) {
            // setShowPriceInfo(false);

            // reset date and time to the current datetime + 1 hour show price modal is opened and promoPrice if there is no promo price
            if (!promoPrice) {
                resetExpiry();
            } else if (!prevPpvPrice && ppvPrice) {
                setPrevPpvPrice(ppvPrice);
                setPrevPromoPrice(promoPrice);
                setPrevExpiry(expiry);
                setPrevIsDiscounted(isDiscounted);
            }
        } else {
            // if(ppvPrice > 0) {
            //     setShowPriceInfo(true);
            // }

            if (!promoPrice) {
                setIsDiscounted(false);
            }
        }
    }, [showPrice]);

    const openUserListModal = () => {
        dispatch(toggleUserListModal(!userListModalRdx));
    };

    const handleUserListFilter = (step, count) => {
        setUserCount(count);
        setNewMsgStep(step);
    };

    useEffect(() => {
        setNewMsgChecked(selectedFilter);
    }, [selectedFilter]);

    const clearLocationState = () => {
        // Extract pathname, search, and hash from current location
        const { pathname, search, hash } = location;

        // Create a new location object without state
        const newLocation = {
            pathname,
            search,
            hash,
        };

        // Replace current location with the new one without state
        history.replace(newLocation);
    };

    const handleSendEmailChange = (e) => {
        setSendEmail(!sendEmail);
    };

    return (
        <MessageContext.Provider
            value={{ sendBy, setSendBy, setNewMsgChecked }}
        >
            <>
                {orderModal && (
                    <OrderModal
                        show={orderModal}
                        medias={mediaFiles}
                        setMedias={setMediaFiles}
                        album={activeEditAlbumObject}
                        pauseStashLoadMore={pauseStashLoadMore}
                        stashEnd={pauseStashLoadMore}
                    />
                )}

                {showToast && (
                    <PRainbowToast
                        show={showToast}
                        setShow={setShowToast}
                        message={`Copied Link to ${process.env.MIX_APP_URL}/${
                            user ? user.login : ""
                        } profile!`}
                        customStyle={{ top: 75, left: "40%" }}
                    />
                )}

                {showStatsModal && (
                    <PpvStatistics
                        showStatsModal={showStatsModal}
                        active={active}
                        handleStatsModal={handleStatsModal}
                        ppvFilter={ppvFilter}
                        setPpvFilter={setPpvFilter}
                        statsLogin={statsLogin}
                        statsType={statsType}
                    />
                )}

                {statsListInfoModalIsOpen && (
                    <ModalBootstrap
                        show={statsListInfoModalIsOpen}
                        onHide={handleStatsListInfoModal}
                        className="blockuser-modal stats-info-modal"
                        centered
                        size="md"
                    >
                        <ModalBootstrap.Header>
                            <CloseButton
                                className="close"
                                onClick={handleStatsListInfoModal}
                                style={{
                                    position: "absolute",
                                    top: "32px",
                                    right: "12px",
                                }}
                            />
                            <ModalBootstrap.Title>
                                Remove for all subscribers (Paid PPVs are not
                                removed)
                            </ModalBootstrap.Title>
                        </ModalBootstrap.Header>
                        <ModalBootstrap.Body />
                    </ModalBootstrap>
                )}

                {showCreateAlbum && (
                    <ModalBootstrap
                        show={showCreateAlbum}
                        onHide={handleCreateNewAlbum}
                        className="createAlbum-modal"
                        centered
                        size="md"
                    >
                        <ModalBootstrap.Header>
                            <ModalBootstrap.Title>
                                Create New Album
                            </ModalBootstrap.Title>
                        </ModalBootstrap.Header>
                        <ModalBootstrap.Body>
                            <div className="create_album_cont">
                                <p>
                                    Album Name
                                    <br />
                                    <input
                                        type="text"
                                        defaultValue={albumName}
                                        onChange={onChangeAlbumName}
                                    />
                                </p>
                            </div>
                            <div className="create-album-buttons">
                                <span
                                    className="close-fancy"
                                    onClick={() => {
                                        handleCreateNewAlbum();
                                        handleMovetoFolder();
                                    }}
                                >
                                    CANCEL
                                </span>
                                <span
                                    className="save-create-album"
                                    onClick={() => {
                                        saveNewAlbum();
                                        handleCreateNewAlbum();
                                    }}
                                >
                                    SAVE
                                </span>
                            </div>
                        </ModalBootstrap.Body>
                    </ModalBootstrap>
                )}

                {showRenameFolder && (
                    <ModalBootstrap
                        show={showRenameFolder}
                        onHide={handleShowRenameFolder}
                        className="renamefolder-modal"
                        centered
                        size="sm"
                    >
                        <ModalBootstrap.Header>
                            <ModalBootstrap.Title>
                                Rename Album
                            </ModalBootstrap.Title>
                        </ModalBootstrap.Header>
                        <ModalBootstrap.Body>
                            <div className="rename_album_cont">
                                <p>
                                    Album Name
                                    <br />
                                    <input
                                        type="text"
                                        defaultValue={renameAlbum}
                                        onChange={onChangeRenameAlbum}
                                    />
                                </p>
                            </div>
                            <div className="new-album-buttons">
                                <span
                                    href="#"
                                    className="close-fancy"
                                    onClick={handleShowRenameFolder}
                                >
                                    CANCEL
                                </span>
                                <span
                                    href="#"
                                    className="save-rename-album"
                                    onClick={() => {
                                        updateAlbumName();
                                        handleShowRenameFolder();
                                    }}
                                >
                                    SAVE
                                </span>
                            </div>
                        </ModalBootstrap.Body>
                    </ModalBootstrap>
                )}

                {showMoveFolder && (
                    <ModalBootstrap
                        show={showMoveFolder}
                        onHide={handleMovetoFolder}
                        className="movefolder-modal"
                        centered
                        size="md"
                    >
                        <ModalBootstrap.Header>
                            <CloseButton
                                className="close"
                                onClick={handleMovetoFolder}
                                style={{
                                    position: "absolute",
                                    top: "32px",
                                    right: "12px",
                                }}
                            />
                            <ModalBootstrap.Title>
                                Copy to Album
                                <span>{stashSelected.length} selected</span>
                            </ModalBootstrap.Title>
                        </ModalBootstrap.Header>
                        <ModalBootstrap.Body>
                            <table>
                                <tbody>
                                    {albumList &&
                                        albumList.map((k) => (
                                            <tr key={k.id}>
                                                <td className="movefolder-checkbox">
                                                    <label>
                                                        <input
                                                            type="checkbox"
                                                            value={k.id}
                                                            checked={moveAlbumList.find(
                                                                (element) =>
                                                                    element.get_val ==
                                                                    k.id
                                                            )}
                                                            onChange={
                                                                updateMoveAlbumList
                                                            }
                                                        />
                                                        <span />
                                                    </label>
                                                </td>
                                                <td
                                                    className="open_album"
                                                    onClick={() => {
                                                        () =>
                                                            handleSelectAlbum(
                                                                k
                                                            );
                                                    }}
                                                >
                                                    <b>{k.album_name}</b>
                                                    <br />{" "}
                                                    <span className="album_stats">
                                                        <FontAwesomeIcon
                                                            icon={[
                                                                "fas",
                                                                "image",
                                                            ]}
                                                        />{" "}
                                                        {k.medias_img_count}{" "}
                                                        &nbsp;{" "}
                                                        <FontAwesomeIcon
                                                            className="album_three_dot"
                                                            icon={[
                                                                "fas",
                                                                "video",
                                                            ]}
                                                        />{" "}
                                                        {k.medias_video_count}
                                                    </span>
                                                </td>
                                                <td className="album-thumb-col open_album">
                                                    <div className="thumb-col-img" />
                                                </td>
                                            </tr>
                                        ))}
                                </tbody>
                            </table>
                        </ModalBootstrap.Body>
                        <ModalBootstrap.Footer>
                            <div className="moveAlbum-footer-btns">
                                <a
                                    onClick={() => {
                                        handleCreateNewAlbum();
                                        handleMovetoFolder();
                                    }}
                                >
                                    + New Album
                                </a>
                                <a
                                    className={`add-to-album ${
                                        moveAlbumList.length == 0
                                            ? "disabled"
                                            : ""
                                    }`}
                                    onClick={() => {
                                        handleAddtoAlbum();
                                    }}
                                >
                                    Add to Album
                                </a>
                            </div>
                        </ModalBootstrap.Footer>
                    </ModalBootstrap>
                )}

                {showAlert && (
                    <AlertConfirm
                        show={showAlert}
                        modalBody={modalBody}
                        setShow={setShowAlert}
                        isConfirm={hasConfirm}
                        setConfirm={setConfirmAction}
                        useFunction={deleteAlbum}
                    />
                )}

                <div
                    className={`msgOptionOverlay ${
                        msgOptionOpen != "" ? "show" : ""
                    }`}
                    onClick={() => updateMsgOptionOpen("")}
                />
                <div className="messenger-content">
                    {busyBlocks ? (
                        <div className="chat_block_cont">
                            <Spinner
                                size="sm"
                                animation="border"
                                variant="primary"
                            />
                        </div>
                    ) : (
                        <>
                            {openNotes ? (
                                <PersonalNotes su={user} />
                            ) : handleShowChatGallery() ? (
                                <ChatGallery
                                    key={`${Math.round()}`}
                                    pu={user}
                                    user={userInformation}
                                    activeMessage={active}
                                />
                            ) : (
                                <>
                                    <span
                                        className="stash_sales_clicker"
                                        onClick={() => handleStatsModal("all")}
                                    />

                                    {activeConv ? (
                                        <div
                                            ref={messengerHeaderRef}
                                            className={`${setChatMessageHeader()}`}
                                        >
                                            <div
                                                ref={userInfoRef}
                                                className="user-info-container"
                                            >
                                                <div
                                                    ref={returnButtonRef}
                                                    className="back-btn um-message-hide um-tip-e"
                                                    onClick={
                                                        handleBackToSidebar
                                                    }
                                                >
                                                    <i className="fa-regular fa-chevron-left" />
                                                </div>
                                                <div className="active-user-name">
                                                    <div className="current-user">
                                                        <div className="usrname">
                                                            <div
                                                                className="ellipsis-overflow"
                                                                style={{
                                                                    width: userInfoWidth
                                                                        ? userInfoWidth
                                                                        : "auto",
                                                                }}
                                                            >
                                                                {user && (
                                                                    <a
                                                                        href={`/${user.login}`}
                                                                    >
                                                                        {
                                                                            user.login
                                                                        }
                                                                    </a>
                                                                )}
                                                            </div>
                                                            {isOnline && (
                                                                <div className="current-user__availability">
                                                                    <span></span>{" "}
                                                                    Available
                                                                    Now
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            {userDetails &&
                                                userDetails.role ===
                                                    ROLES.SU && (
                                                    <div
                                                        className={
                                                            "su-action-btns"
                                                        }
                                                    >
                                                        <div
                                                            className="chat-gallery-btn"
                                                            onClick={
                                                                handleOpenChatGallery
                                                            }
                                                        >
                                                            <i className="fa-solid fa-image"></i>{" "}
                                                            <span
                                                                class={
                                                                    "chat-gallery-text"
                                                                }
                                                            >
                                                                Chat Gallery{" "}
                                                            </span>
                                                        </div>
                                                        <Mute
                                                            isMute={muteVal}
                                                            active={active}
                                                        />
                                                    </div>
                                                )}
                                            {userDetails &&
                                                userDetails.role ===
                                                    ROLES.PU && (
                                                    <div
                                                        className={
                                                            "pu-action-btns"
                                                        }
                                                        ref={actionButtonsRef}
                                                    >
                                                        {!busyBlocks &&
                                                            blockedUsers.indexOf(
                                                                user.id
                                                            ) < 0 && (
                                                                <div
                                                                    onClick={
                                                                        handleBlockModal
                                                                    }
                                                                    className="mr-1 block-user-btn"
                                                                    style={{
                                                                        display:
                                                                            "flex",
                                                                        alignItems:
                                                                            "center",
                                                                        gap: "5px",
                                                                        fontSize:
                                                                            "16px",
                                                                        cursor: "pointer",
                                                                    }}
                                                                >
                                                                    <FontAwesomeIcon
                                                                        icon={[
                                                                            "fas",
                                                                            "ban",
                                                                        ]}
                                                                    />{" "}
                                                                    <span className="block_text hidden-md hidden-sm">
                                                                        Block
                                                                    </span>
                                                                </div>
                                                            )}

                                                        {!busyBlocks &&
                                                            blockedUsers.indexOf(
                                                                user.id
                                                            ) >= 0 && (
                                                                <div
                                                                    onClick={
                                                                        handleUnblock
                                                                    }
                                                                    className="mr-1"
                                                                    style={{
                                                                        display:
                                                                            "flex",
                                                                        alignItems:
                                                                            "center",
                                                                        gap: "5px",
                                                                        fontSize:
                                                                            "16px",
                                                                        cursor: "pointer",
                                                                    }}
                                                                >
                                                                    <FontAwesomeIcon
                                                                        icon={[
                                                                            "fas",
                                                                            "ban",
                                                                        ]}
                                                                    />{" "}
                                                                    <span className="block_text hidden-md hidden-sm">
                                                                        Unblock
                                                                    </span>
                                                                </div>
                                                            )}

                                                        <Mute
                                                            isMute={muteVal}
                                                            active={active}
                                                        />
                                                        <div
                                                            className="chat_favourite"
                                                            onClick={
                                                                handleFavourite
                                                            }
                                                        >
                                                            {favourite ? (
                                                                <i className="fa-solid fa-star"></i>
                                                            ) : (
                                                                <i className="fa-regular fa-star"></i>
                                                            )}{" "}
                                                            <span className="fave_desktop">
                                                                Favourite
                                                            </span>
                                                        </div>
                                                        <div
                                                            className="view_su_stats"
                                                            onClick={() =>
                                                                handleStatsModal(
                                                                    "single",
                                                                    user.login
                                                                )
                                                            }
                                                        >
                                                            <i className="fa-regular fa-square-dollar"></i>
                                                            {!isMobile ? (
                                                                <span className="stash_sales">
                                                                    Sales
                                                                </span>
                                                            ) : (
                                                                " "
                                                            )}
                                                        </div>
                                                        <div className="chat_extra_options">
                                                            <div className="chat_extra_options_inside">
                                                                <Dropdown>
                                                                    <Dropdown.Toggle
                                                                        variant="success"
                                                                        className="chat-moreoption mx-3"
                                                                        id="dropdown-basic"
                                                                    >
                                                                        <FontAwesomeIcon
                                                                            icon={[
                                                                                "fas",
                                                                                "ellipsis-v",
                                                                            ]}
                                                                        />
                                                                    </Dropdown.Toggle>

                                                                    <Dropdown.Menu>
                                                                        <Dropdown.Item
                                                                            onClick={
                                                                                openUserListModal
                                                                            }
                                                                        >
                                                                            Add
                                                                            to
                                                                            user
                                                                            list
                                                                        </Dropdown.Item>
                                                                        <Dropdown.Item
                                                                            onClick={(
                                                                                e
                                                                            ) =>
                                                                                openPersonalNote(
                                                                                    e
                                                                                )
                                                                            }
                                                                        >
                                                                            Personal
                                                                            Note
                                                                        </Dropdown.Item>
                                                                        <CopyToClipboard
                                                                            text={`${
                                                                                process
                                                                                    .env
                                                                                    .MIX_APP_URL
                                                                            }/${
                                                                                user
                                                                                    ? user.login
                                                                                    : ""
                                                                            }`}
                                                                            onCopy={() =>
                                                                                setShowToast(
                                                                                    true
                                                                                )
                                                                            }
                                                                        >
                                                                            <Dropdown.Item>
                                                                                Copy
                                                                                link
                                                                                to
                                                                                profile
                                                                            </Dropdown.Item>
                                                                        </CopyToClipboard>

                                                                        <Dropdown.Item
                                                                            onClick={
                                                                                changeMute
                                                                            }
                                                                        >
                                                                            {!muteVal
                                                                                ? `Mute @${
                                                                                      user
                                                                                          ? user.login
                                                                                          : ""
                                                                                  }`
                                                                                : `Unmute @${
                                                                                      user
                                                                                          ? user.login
                                                                                          : ""
                                                                                  }`}
                                                                        </Dropdown.Item>

                                                                        {blockedUsers.indexOf(
                                                                            user.id
                                                                        ) >=
                                                                        0 ? (
                                                                            <Dropdown.Item
                                                                                onClick={
                                                                                    handleUnblock
                                                                                }
                                                                            >
                                                                                Unblock
                                                                                @
                                                                                {user
                                                                                    ? user.login
                                                                                    : ""}
                                                                            </Dropdown.Item>
                                                                        ) : (
                                                                            <Dropdown.Item
                                                                                onClick={
                                                                                    handleBlockModal
                                                                                }
                                                                            >
                                                                                Block
                                                                                @
                                                                                {user
                                                                                    ? user.login
                                                                                    : ""}
                                                                            </Dropdown.Item>
                                                                        )}
                                                                    </Dropdown.Menu>
                                                                </Dropdown>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
                                        </div>
                                    ) : null}

                                    {loading ? (
                                        <div className="messenger-main">
                                            Loading
                                        </div>
                                    ) : (
                                        <ChatMessage
                                            scrollBottomTrigger={
                                                scrollBottomTrigger
                                            }
                                            setScrollBottomTrigger={
                                                setScrollBottomTrigger
                                            }
                                            active={active}
                                            setActive={setActive}
                                            setShowLoader={setShowLoader}
                                            newLineCount={newLineCount}
                                            showPrice={showPrice}
                                            newMessage={newMessage}
                                            setNewMessage={setNewMessage}
                                            newMessageObject={newMessageObject}
                                            uuid={uuid}
                                            responseMessage={responseMessage}
                                            loadMessageTrigger={
                                                loadMessageTrigger
                                            }
                                            receiverDetails={user}
                                            isCurrentlyTyping={
                                                isCurrentlyTyping
                                            }
                                            forceStopTypingIndicator={
                                                forceStopTypingIndicator
                                            }
                                            marginTop={chatMessageMarginTop}
                                        />
                                    )}

                                    <div
                                        className="messenger-controls um-message-footer um-popup-footer"
                                        ref={textAreaRef}
                                    >
                                        {
                                            // ppvPrice > 0 && showPriceInfo && !broadcastModal
                                            ppvPrice > 0 && !broadcastModal ? (
                                                <PriceInformation className="create-ppv-price">
                                                    <div>
                                                        {/* <span>Price: <PriceText price={ppvPrice} discountedPrice={promoPrice} isDiscounted /> {isDiscounted ? <React.Fragment> Limited offer expires in <CountDownTimer dateTime={countDownExpiryDate} onEndTime={handleEndTime} /></React.Fragment> : ''} </span> */}
                                                        <span>
                                                            Price:{" "}
                                                            <PriceText
                                                                price={ppvPrice}
                                                                discountedPrice={
                                                                    promoPrice
                                                                }
                                                                isDiscounted
                                                            />{" "}
                                                            {promoPrice &&
                                                            isDiscounted ? (
                                                                <React.Fragment>
                                                                    {" "}
                                                                    Limited
                                                                    offer
                                                                    expires in{" "}
                                                                    {expiry.days >
                                                                    0
                                                                        ? expiry.days >
                                                                          1
                                                                            ? `${expiry.days} days `
                                                                            : "1 day "
                                                                        : ""}{" "}
                                                                    {expiry.hours >
                                                                    0
                                                                        ? expiry.hours >
                                                                          1
                                                                            ? `${expiry.hours} hrs `
                                                                            : "1 hr "
                                                                        : ""}{" "}
                                                                    {expiry.minutes >
                                                                    0
                                                                        ? expiry.minutes >
                                                                          1
                                                                            ? `${expiry.minutes} mins `
                                                                            : "1 min"
                                                                        : ""}
                                                                </React.Fragment>
                                                            ) : (
                                                                ""
                                                            )}{" "}
                                                        </span>
                                                    </div>
                                                    <ClosePriceInformation>
                                                        <IconButton
                                                            color="primary"
                                                            onClick={
                                                                handlePriceInformationClose
                                                            }
                                                        >
                                                            <i className="fal fa-times search-clear-icon"></i>
                                                        </IconButton>
                                                    </ClosePriceInformation>
                                                </PriceInformation>
                                            ) : (
                                                ""
                                            )
                                        }

                                        {!muteVal &&
                                            !muteOtherVal &&
                                            activeConv && (
                                                <div className="chat-action">
                                                    <div className="act-reply-bx ">
                                                        <PTextareaChat
                                                            placeholder={
                                                                chatPlaceholder
                                                            }
                                                            user={user}
                                                            followerDetails={
                                                                followerDetails
                                                            }
                                                            active={active}
                                                            ppvPrice={ppvPrice}
                                                            setPpvPrice={
                                                                setPpvPrice
                                                            }
                                                            setAttach={
                                                                setAttach
                                                            }
                                                            setPpvPriceError={
                                                                setPpvPriceError
                                                            }
                                                            minPpvPrice={
                                                                minPpvPrice
                                                            }
                                                            maxPpvPrice={
                                                                maxPpvPrice
                                                            }
                                                            setNewLineCount={
                                                                setNewLineCount
                                                            }
                                                            setMediaFiles={
                                                                setMediaFiles
                                                            }
                                                            setMediaSent={
                                                                setMediaSent
                                                            }
                                                            setMediaSold={
                                                                setMediaSold
                                                            }
                                                            disabled={
                                                                disableSendMessage ||
                                                                sending
                                                            }
                                                            // disabled={
                                                            //     disableSendMessage || (userInformation && [ROLES.PU].includes(userInformation.role)
                                                            //         ? (ppvPriceError || sending || (showPrice && stashSelected.length == 0) || (showPrice && ppvPrice == ''))
                                                            //         : sending) || ![0, 1].includes(followStatus)
                                                            // }
                                                            setNewMessage={
                                                                setNewMessage
                                                            }
                                                            setInput={
                                                                setCaption
                                                            }
                                                            setUuid={setUuid}
                                                            uuid={uuid}
                                                            setResponseMessage={
                                                                setResponseMessage
                                                            }
                                                            freePreview={
                                                                freePreview
                                                            }
                                                            resetMarginTop={() =>
                                                                setChatMessageMarginTop(
                                                                    DEFAULT_CHAT_MESSAGE_MARGIN_TOP
                                                                )
                                                            }
                                                            hidePriceInput={() =>
                                                                updateShowPrice(
                                                                    false
                                                                )
                                                            }
                                                            promoPrice={
                                                                promoPrice ===
                                                                ""
                                                                    ? 0
                                                                    : promoPrice
                                                            }
                                                            setPromoPrice={
                                                                setPromoPrice
                                                            }
                                                            expiry={expiry}
                                                            resetPriceModal={
                                                                resetPriceModal
                                                            }
                                                        />
                                                    </div>

                                                    {/* Individual Chat */}
                                                    <div className="chat-buttons">
                                                        <div className="chat-buttons-left">
                                                            {userDetails &&
                                                            Object.keys(
                                                                userDetails
                                                            ).length > 0 &&
                                                            [
                                                                ROLES.PU,
                                                                ROLES.ADMIN,
                                                            ].includes(
                                                                userDetails.role
                                                            ) ? (
                                                                <span
                                                                    className="chat-btn-cont"
                                                                    onClick={() =>
                                                                        disableSendMessage
                                                                            ? {}
                                                                            : openModal(
                                                                                  "",
                                                                                  "chat"
                                                                              )
                                                                    }
                                                                >
                                                                    <i className="fa-regular fa-photo-film"></i>
                                                                </span>
                                                            ) : (
                                                                <span
                                                                    className={`chat-btn-cont${
                                                                        ![
                                                                            0,
                                                                            1,
                                                                        ].includes(
                                                                            followStatus
                                                                        )
                                                                            ? " hidden"
                                                                            : ""
                                                                    }`}
                                                                    {...getRootProps()}
                                                                >
                                                                    {disableSendMessage ? (
                                                                        ""
                                                                    ) : (
                                                                        <input
                                                                            {...getInputProps()}
                                                                        />
                                                                    )}

                                                                    {isDragActive ? (
                                                                        <p>
                                                                            Drop
                                                                            the
                                                                            files
                                                                            here
                                                                            ...
                                                                        </p>
                                                                    ) : (
                                                                        <i
                                                                            className={`fa-regular fa-photo-film ${
                                                                                disableSendMessage
                                                                                    ? "disabled"
                                                                                    : ""
                                                                            }`}
                                                                        ></i>
                                                                    )}
                                                                </span>
                                                            )}

                                                            {userDetails &&
                                                            userDetails.role ==
                                                                ROLES.PU ? (
                                                                <span
                                                                    className={`chat-btn-cont${
                                                                        !broadcastModal &&
                                                                        showPrice
                                                                            ? " active"
                                                                            : ""
                                                                    }`}
                                                                    onClick={
                                                                        togglePriceInput
                                                                    }
                                                                >
                                                                    <i className="fa-regular fa-circle-dollar" />
                                                                </span>
                                                            ) : (
                                                                ""
                                                            )}

                                                            {!broadcastModal &&
                                                            (showPrice ||
                                                                (userDetails &&
                                                                    Object.keys(
                                                                        userDetails
                                                                    ).length >
                                                                        0 &&
                                                                    userDetails.role ==
                                                                        ROLES.SU)) ? (
                                                                ""
                                                            ) : (
                                                                <span className="ppv-text">
                                                                    Pay Per View
                                                                </span>
                                                            )}
                                                        </div>
                                                        {!broadcastModal &&
                                                            ppvPrice > 0 && (
                                                                <div
                                                                    className={`dropdown-menu attachment-reminder`}
                                                                    style={
                                                                        stashSelected.length ==
                                                                        0
                                                                            ? {
                                                                                  display:
                                                                                      "inline",
                                                                              }
                                                                            : {}
                                                                    }
                                                                >
                                                                    <span
                                                                        className={`um-message-item-remove ir66 um-message-item-show-on-hover um-tip-s`}
                                                                    >
                                                                        Attach
                                                                        media
                                                                        file/s
                                                                    </span>
                                                                </div>
                                                            )}
                                                    </div>
                                                </div>
                                            )}
                                        {Boolean(muteOtherVal) && (
                                            <div className="act-text um-message-textarea">
                                                <div className="muted-textbox">
                                                    This user has muted you from
                                                    sending or receiving
                                                    messages.
                                                </div>
                                            </div>
                                        )}
                                        {Boolean(muteVal) && (
                                            <div
                                                className="act-text um-message-textarea"
                                                style={{ paddingTop: "12px" }}
                                            >
                                                <div className="muted-textbox">
                                                    Unmute user to send and
                                                    receive messages
                                                </div>
                                            </div>
                                        )}

                                        {/* STASH MODAL */}
                                        {show && (
                                            <Stash
                                                source="messenger"
                                                resend={handleResend}
                                                resetOnClose={false}
                                                onMessageOrPost={
                                                    onComposeMessage
                                                }
                                                onStashClose={onStashClose}
                                                resending={resending}
                                            />
                                        )}

                                        {msgModalIsOpen && (
                                            <Modal
                                                isOpen={msgModalIsOpen}
                                                style={customStyles}
                                                contentLabel="New Message"
                                                id="newMessageModal"
                                            >
                                                {newMsgStep == 1 && (
                                                    <div className="modal-header text-center">
                                                        <button
                                                            type="button"
                                                            className="close blue-btn-hover blue-btn-hover-new"
                                                            data-dismiss="modal"
                                                        >
                                                            <i
                                                                className="far fa-times"
                                                                onClick={() =>
                                                                    closeNewMsg()
                                                                }
                                                            ></i>
                                                        </button>
                                                        <h4
                                                            className="modal-title"
                                                            id="newmsgtxt"
                                                        >
                                                            New Message
                                                        </h4>
                                                    </div>
                                                )}

                                                {newMsgStep == 2 && (
                                                    <div
                                                        className={
                                                            "modal-header center-text"
                                                        }
                                                    >
                                                        <button
                                                            type="button"
                                                            className="close blue-btn-hover blue-btn-hover-new"
                                                            data-dismiss="modal"
                                                        >
                                                            <i
                                                                className="far fa-times"
                                                                onClick={() =>
                                                                    closeNewMsg()
                                                                }
                                                            ></i>
                                                        </button>
                                                        <div className="back-btn newmsg">
                                                            <span
                                                                id="backtoselectwindow"
                                                                onClick={() =>
                                                                    setNewMsgStep(
                                                                        "1"
                                                                    )
                                                                }
                                                            >
                                                                <i
                                                                    className="fa-regular fa-chevron-left"
                                                                    style={{
                                                                        fontSize:
                                                                            "29px",
                                                                    }}
                                                                ></i>
                                                            </span>
                                                        </div>
                                                        {nextLoading ? (
                                                            <div className="nextLoadingCont">
                                                                <Spinner
                                                                    size="sm"
                                                                    animation="border"
                                                                />
                                                            </div>
                                                        ) : (
                                                            <h4
                                                                className="modal-title send-message-title"
                                                                id="nosubscriber"
                                                            >
                                                                Send message to{" "}
                                                                {userDetails &&
                                                                userDetails.role ===
                                                                    ROLES.PU
                                                                    ? userCount
                                                                    : newMsgSendSelected.length}{" "}
                                                                user(s)
                                                            </h4>
                                                        )}
                                                    </div>
                                                )}

                                                <div className="modal-body">
                                                    {newMsgStep == 2 && (
                                                        <div
                                                            className={`new-msg-step2`}
                                                        >
                                                            {broadcastModal ? (
                                                                <div className="chat-action">
                                                                    {userInformation.role ==
                                                                    ROLES.ADMIN ? (
                                                                        <div
                                                                            css={css`
                                                                                margin: 0
                                                                                    10px;
                                                                                text-align: left;
                                                                            `}
                                                                        >
                                                                            <Checkbox
                                                                                checked={
                                                                                    sendEmail
                                                                                }
                                                                                onChange={
                                                                                    handleSendEmailChange
                                                                                }
                                                                                inputProps={{
                                                                                    "aria-label":
                                                                                        "controlled",
                                                                                }}
                                                                            />
                                                                        </div>
                                                                    ) : null}
                                                                    {ppvPrice >
                                                                        0 &&
                                                                    broadcastModal ? (
                                                                        <PriceInformation className="create-ppv-price">
                                                                            <div>
                                                                                {/* <span>Price: <PriceText price={ppvPrice} discountedPrice={promoPrice} isDiscounted /> {isDiscounted ? <React.Fragment> Limited offer expires in <CountDownTimer dateTime={countDownExpiryDate} onEndTime={handleEndTime} /></React.Fragment> : ''} </span> */}
                                                                                <span>
                                                                                    Price:{" "}
                                                                                    <PriceText
                                                                                        price={
                                                                                            ppvPrice
                                                                                        }
                                                                                        discountedPrice={
                                                                                            promoPrice
                                                                                        }
                                                                                        isDiscounted
                                                                                    />{" "}
                                                                                    {promoPrice &&
                                                                                    isDiscounted ? (
                                                                                        <React.Fragment>
                                                                                            {" "}
                                                                                            Limited
                                                                                            offer
                                                                                            expires
                                                                                            in{" "}
                                                                                            {expiry.days >
                                                                                            0
                                                                                                ? expiry.days >
                                                                                                  1
                                                                                                    ? `${expiry.days} days `
                                                                                                    : "1 day "
                                                                                                : ""}{" "}
                                                                                            {expiry.hours >
                                                                                            0
                                                                                                ? expiry.hours >
                                                                                                  1
                                                                                                    ? `${expiry.hours} hrs `
                                                                                                    : "1 hr "
                                                                                                : ""}{" "}
                                                                                            {expiry.minutes >
                                                                                            0
                                                                                                ? expiry.minutes >
                                                                                                  1
                                                                                                    ? `${expiry.minutes} mins `
                                                                                                    : "1 min"
                                                                                                : ""}
                                                                                        </React.Fragment>
                                                                                    ) : (
                                                                                        ""
                                                                                    )}{" "}
                                                                                </span>
                                                                            </div>
                                                                            <ClosePriceInformation>
                                                                                <IconButton
                                                                                    color="primary"
                                                                                    onClick={
                                                                                        handlePriceInformationClose
                                                                                    }
                                                                                >
                                                                                    <i className="fal fa-times search-clear-icon"></i>
                                                                                </IconButton>
                                                                            </ClosePriceInformation>
                                                                        </PriceInformation>
                                                                    ) : (
                                                                        ""
                                                                    )}
                                                                    <div className="act-reply-bx">
                                                                        <div className="act-text um-message-textarea">
                                                                            <PTextareaBroadcast
                                                                                placeholder={
                                                                                    "Type your message"
                                                                                }
                                                                                user={
                                                                                    user
                                                                                }
                                                                                onKeyDown={
                                                                                    handleKeySend
                                                                                }
                                                                                active={
                                                                                    active
                                                                                }
                                                                                updateBroadcastMsg={
                                                                                    onChangeInputBroadcastStr
                                                                                }
                                                                                setNewLineCount={
                                                                                    setNewLineCount
                                                                                }
                                                                                resetPriceModal={
                                                                                    resetPriceModal
                                                                                }
                                                                            />
                                                                        </div>
                                                                    </div>

                                                                    {/* Broadcast message */}
                                                                    <div className="chat-buttons">
                                                                        <div className="chat-buttons-left">
                                                                            {userDetails &&
                                                                            userDetails.role ===
                                                                                ROLES.PU ? (
                                                                                <span
                                                                                    className={`chat-btn-cont send-message-chat`}
                                                                                    onClick={() =>
                                                                                        openModal(
                                                                                            "broadcast"
                                                                                        )
                                                                                    }
                                                                                >
                                                                                    <i className="fa-regular fa-photo-film"></i>
                                                                                </span>
                                                                            ) : (
                                                                                <span
                                                                                    className={`chat-btn-cont`}
                                                                                    {...getRootProps()}
                                                                                >
                                                                                    <input
                                                                                        {...getInputProps()}
                                                                                    />
                                                                                    {isDragActive ? (
                                                                                        <p>
                                                                                            Drop
                                                                                            the
                                                                                            files
                                                                                            here
                                                                                            ...
                                                                                        </p>
                                                                                    ) : (
                                                                                        <i className="fa-regular fa-photo-film"></i>
                                                                                    )}
                                                                                </span>
                                                                            )}

                                                                            {userDetails &&
                                                                                userDetails.role ==
                                                                                    ROLES.PU && (
                                                                                    <span
                                                                                        className={`chat-btn-cont${
                                                                                            showPrice
                                                                                                ? " active"
                                                                                                : ""
                                                                                        }`}
                                                                                        onClick={
                                                                                            togglePriceInput
                                                                                        }
                                                                                    >
                                                                                        <i className="fa-regular fa-circle-dollar"></i>
                                                                                    </span>
                                                                                )}

                                                                            {ppvPrice >
                                                                            0 ? (
                                                                                ""
                                                                            ) : userDetails &&
                                                                              userDetails.role ==
                                                                                  1 ? (
                                                                                <span className="ppv-text">
                                                                                    Pay
                                                                                    Per
                                                                                    View{" "}
                                                                                </span>
                                                                            ) : (
                                                                                ""
                                                                            )}

                                                                            <div className="broadcast-send">
                                                                                <button
                                                                                    className="btn btn-sm btn-primary btn-rounded"
                                                                                    onClick={
                                                                                        submitBroadcast
                                                                                    }
                                                                                    disabled={
                                                                                        disableBroadcastSendMessage
                                                                                    }
                                                                                >
                                                                                    Send
                                                                                </button>
                                                                            </div>
                                                                        </div>

                                                                        {showPrice && (
                                                                            <div
                                                                                className="dropdown-menu attachment-reminder"
                                                                                style={
                                                                                    stashSelected.length ==
                                                                                    0
                                                                                        ? {
                                                                                              display:
                                                                                                  "inline",
                                                                                          }
                                                                                        : {}
                                                                                }
                                                                            >
                                                                                <span
                                                                                    className={`um-message-item-remove ir66 um-message-item-show-on-hover um-tip-s`}
                                                                                >
                                                                                    Attach
                                                                                    media
                                                                                    file/s
                                                                                </span>
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                    {/* </form> */}
                                                                </div>
                                                            ) : (
                                                                ""
                                                            )}
                                                            {muteVal &&
                                                            !broadcastModal ? (
                                                                <div
                                                                    className="act-text um-message-textarea"
                                                                    style={{
                                                                        paddingTop:
                                                                            "12px",
                                                                    }}
                                                                >
                                                                    <div className="muted-textbox">
                                                                        Unmute
                                                                        user to
                                                                        send and
                                                                        receive
                                                                        messages
                                                                    </div>
                                                                </div>
                                                            ) : (
                                                                ""
                                                            )}

                                                            {!stashSidebar && (
                                                                <>
                                                                    {files.length >
                                                                    0 ? (
                                                                        <div className="messenger-attachments">
                                                                            {/* Loop this one for multiple */}
                                                                            {files.map(
                                                                                (
                                                                                    i,
                                                                                    k
                                                                                ) => (
                                                                                    <div
                                                                                        key={`img-${k}`}
                                                                                        className="msg-a-item"
                                                                                    >
                                                                                        <span
                                                                                            className="close remove-stash"
                                                                                            onClick={() =>
                                                                                                removeItem(
                                                                                                    k
                                                                                                )
                                                                                            }
                                                                                        >
                                                                                            <FontAwesomeIcon
                                                                                                icon={[
                                                                                                    "fas",
                                                                                                    "times",
                                                                                                ]}
                                                                                            />
                                                                                        </span>
                                                                                        <div
                                                                                            className="msg-img"
                                                                                            style={{
                                                                                                backgroundImage: `url(${URL.createObjectURL(
                                                                                                    i
                                                                                                )})`,
                                                                                            }}
                                                                                        />
                                                                                    </div>
                                                                                )
                                                                            )}
                                                                        </div>
                                                                    ) : (
                                                                        <div className="bobex">
                                                                            {stashSelected.length >
                                                                                0 && (
                                                                                <button
                                                                                    className="btn btn-dark uploadBtn"
                                                                                    onClick={() => {
                                                                                        uploadFiles(
                                                                                            this
                                                                                        );
                                                                                    }}
                                                                                >
                                                                                    Upload
                                                                                </button>
                                                                            )}

                                                                            {stashSelected.length >
                                                                            0 ? (
                                                                                <>
                                                                                    {uploading && (
                                                                                        <div className="progress">
                                                                                            <div
                                                                                                className="progress-bar"
                                                                                                role="progressbar"
                                                                                                style={{
                                                                                                    width: progress,
                                                                                                }}
                                                                                                aria-valuenow={
                                                                                                    progress
                                                                                                }
                                                                                                aria-valuemin="0"
                                                                                                aria-valuemax="100"
                                                                                            />
                                                                                        </div>
                                                                                    )}

                                                                                    <div className="images ppv-images-cont">
                                                                                        {stashSelected?.length >
                                                                                            0 && (
                                                                                            <StashSelected
                                                                                                medias={
                                                                                                    stashSelected
                                                                                                }
                                                                                                addSelectStash={
                                                                                                    addSelectStash
                                                                                                }
                                                                                                handleSelectFreePreview={
                                                                                                    handleSelectFreePreview
                                                                                                }
                                                                                                freePreview={
                                                                                                    freePreview
                                                                                                }
                                                                                                ppvPrice={
                                                                                                    ppvPrice
                                                                                                }
                                                                                                setStashSelected={
                                                                                                    setStashSelected
                                                                                                }
                                                                                                setReshuffled={
                                                                                                    setReshuffled
                                                                                                }
                                                                                                reshuffled={
                                                                                                    reshuffled
                                                                                                }
                                                                                            />
                                                                                        )}
                                                                                    </div>
                                                                                </>
                                                                            ) : (
                                                                                <div className="no-images">
                                                                                    <h5 className="text-center" />
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                    )}
                                                                </>
                                                            )}
                                                        </div>
                                                    )}

                                                    {newMsgStep == 1 && (
                                                        <div
                                                            className={`new-msg-step1`}
                                                        >
                                                            <div className="filter">
                                                                <div className="sb-msg-info">
                                                                    *Messages to
                                                                    multiple
                                                                    recipients
                                                                    will be sent
                                                                    individually
                                                                    i.e. NO
                                                                    group chat
                                                                </div>
                                                                {selectedFilter && (
                                                                    <div
                                                                        style={{
                                                                            padding:
                                                                                "0 15px",
                                                                        }}
                                                                    >
                                                                        <Exclude
                                                                            sus={
                                                                                excludeList
                                                                            }
                                                                            excluded={
                                                                                excluded
                                                                            }
                                                                            setExcluded={
                                                                                setExcluded
                                                                            }
                                                                        />
                                                                    </div>
                                                                )}
                                                                <div className=" attireBlock mod1 filter__search">
                                                                    {selectedFilter ==
                                                                        "" && (
                                                                        <>
                                                                            <form
                                                                                className="attireCodeToggleBlock"
                                                                                action=""
                                                                            >
                                                                                <NewMessageUserMultiSelect
                                                                                    newMsgSendSelected={
                                                                                        newMsgSendSelected
                                                                                    }
                                                                                    setNewMsgSendSelected={
                                                                                        setNewMsgSendSelected
                                                                                    }
                                                                                    disabled={
                                                                                        selectedFilter !=
                                                                                        ""
                                                                                    }
                                                                                />
                                                                            </form>
                                                                        </>
                                                                    )}
                                                                </div>

                                                                {userDetails &&
                                                                    userDetails.role ==
                                                                        ROLES.SU && (
                                                                        <div className="next-btn">
                                                                            {(newMsgSendSelected.length !==
                                                                                0 ||
                                                                                newMessageSelect !==
                                                                                    0) && (
                                                                                <table
                                                                                    cellSpacing={
                                                                                        0
                                                                                    }
                                                                                    cellPadding={
                                                                                        0
                                                                                    }
                                                                                    border="0"
                                                                                >
                                                                                    <tbody>
                                                                                        <tr>
                                                                                            <td width="90%">
                                                                                                &nbsp;
                                                                                            </td>
                                                                                            <td
                                                                                                align="right"
                                                                                                style={{
                                                                                                    textAlign:
                                                                                                        "right",
                                                                                                }}
                                                                                            >
                                                                                                <button
                                                                                                    id="nxtbtn"
                                                                                                    onClick={() =>
                                                                                                        handleNextStep()
                                                                                                    }
                                                                                                    type="button"
                                                                                                    className="btn btn-primary"
                                                                                                    style={{
                                                                                                        float: "right",
                                                                                                    }}
                                                                                                >
                                                                                                    Next
                                                                                                </button>
                                                                                                <div
                                                                                                    style={{
                                                                                                        clear: "both",
                                                                                                    }}
                                                                                                ></div>
                                                                                            </td>
                                                                                        </tr>
                                                                                    </tbody>
                                                                                </table>
                                                                            )}
                                                                        </div>
                                                                    )}

                                                                {userDetails &&
                                                                    userDetails.role ==
                                                                        ROLES.PU && (
                                                                        <BroadcastFilter
                                                                            // selectedFilter={handleSetNewMessageSelect}
                                                                            setSelectedFilter={
                                                                                handleSelectedFilter
                                                                            }
                                                                            selectedFilter={
                                                                                selectedFilter
                                                                            }
                                                                            setNewMsgStep={
                                                                                setNewMsgStep
                                                                            }
                                                                            setUserCount={
                                                                                setUserCount
                                                                            }
                                                                            setNewMsgSendSelected={
                                                                                setNewMsgSendSelected
                                                                            }
                                                                            newMsgSendSelected={
                                                                                newMsgSendSelected
                                                                            }
                                                                            setRangeIdFromParent={
                                                                                setRangeIdFromParent
                                                                            }
                                                                            setRangeIdToParent={
                                                                                setRangeIdToParent
                                                                            }
                                                                            setLastSubsParent={
                                                                                setLastSubsParent
                                                                            }
                                                                            setPastHoursParent={
                                                                                setPastHoursParent
                                                                            }
                                                                            setRangeDateFromParent={
                                                                                setRangeDateFromParent
                                                                            }
                                                                            setRangeDateToParent={
                                                                                setRangeDateToParent
                                                                            }
                                                                            excluded={
                                                                                excluded
                                                                            }
                                                                        />
                                                                    )}

                                                                {newMsgChecked ==
                                                                    "new" &&
                                                                    newSubsError && (
                                                                        <div className="new_sub_error">
                                                                            {
                                                                                newSubsError
                                                                            }
                                                                            {newSubsError !=
                                                                                "" && (
                                                                                <button
                                                                                    type="button"
                                                                                    className="btn btn-subs-error"
                                                                                    onClick={() =>
                                                                                        confirmSubsError()
                                                                                    }
                                                                                >
                                                                                    OK
                                                                                </button>
                                                                            )}
                                                                        </div>
                                                                    )}
                                                            </div>

                                                            {/* <Divider /> */}

                                                            {/* User lists goes here */}
                                                            {/* <UserListsFilter
                                                                            onSuccess={handleUserListFilter}
                                                                        /> */}

                                                            {/*{selectedFilter === '' &&
                                                                            <div className="avail-user">
                                                                                <h4>Recent Users</h4>
                                                                                <ul className="avail-user-lst" id="myULmul">
                                                                                    {
                                                                                        usersNewMsg.map((i, k) => {
                                                                                            const user = {
                                                                                                id: i.creator == userInformation.id
                                                                                                    ? i.follower
                                                                                                    : i.creator,
                                                                                                login: i.creator == userInformation.id
                                                                                                    ? i.su_login
                                                                                                    : i.pu_login,
                                                                                                profile_pic: Boolean(parseInt(i.creator == userInformation.id
                                                                                                    ? i.su_profile_pic
                                                                                                    : i.pu_profile_pic)),
                                                                                                photo_updated_at: i.creator == userInformation.id
                                                                                                    ? i.su_profile_photo_updated_at
                                                                                                    : i.pu_profile_photo_updated_at
                                                                                            };

                                                                                            return !newMsgSendSelected.find(element => element.id == user.id) ?
                                                                                                <li key={k}
                                                                                                    className="li fstResultItem liUser1"
                                                                                                    onClick={() => newMsgSelectUser(user.login, user.id)}>
                                                                                                    <div
                                                                                                        className="ava-usr-img">
                                                                                                        <Avatar
                                                                                                            story={false}
                                                                                                            size="50"
                                                                                                            pu={user} />
                                                                                                    </div>
                                                                                                    <div
                                                                                                        className="ava-usr-name">
                                                                                                        {user.login}
                                                                                                    </div>
                                                                                                </li>
                                                                                                : null;
                                                                                        })
                                                                                    }
                                                                                </ul>
                                                                            </div>
                                                                        } */}
                                                        </div>
                                                    )}
                                                </div>
                                            </Modal>
                                        )}
                                        {/* Broadcast Modal */}

                                        {activeConv && !stashSidebar && (
                                            <>
                                                {!broadcastModal &&
                                                files.length > 0 ? (
                                                    <div className="messenger-attachments">
                                                        {/* Loop this one for multiple */}
                                                        {files.map((i, k) => (
                                                            <div
                                                                key={`img-${k}`}
                                                                className="msg-a-item"
                                                            >
                                                                <span
                                                                    className="close remove-stash"
                                                                    onClick={() =>
                                                                        removeItem(
                                                                            k
                                                                        )
                                                                    }
                                                                >
                                                                    <FontAwesomeIcon
                                                                        icon={[
                                                                            "fas",
                                                                            "times",
                                                                        ]}
                                                                    />
                                                                </span>
                                                                <div
                                                                    className="msg-img"
                                                                    style={{
                                                                        backgroundImage: `url(${URL.createObjectURL(
                                                                            i
                                                                        )})`,
                                                                    }}
                                                                />
                                                            </div>
                                                        ))}
                                                    </div>
                                                ) : (
                                                    !broadcastModal && (
                                                        <div className="box">
                                                            {stashSelected &&
                                                                stashSelected.length >
                                                                    0 && (
                                                                    <StashSelected
                                                                        medias={
                                                                            stashSelected
                                                                        }
                                                                        addSelectStash={
                                                                            addSelectStash
                                                                        }
                                                                        handleSelectFreePreview={
                                                                            handleSelectFreePreview
                                                                        }
                                                                        freePreview={
                                                                            freePreview
                                                                        }
                                                                        ppvPrice={
                                                                            ppvPrice
                                                                        }
                                                                        setStashSelected={
                                                                            setStashSelected
                                                                        }
                                                                        setReshuffled={
                                                                            setReshuffled
                                                                        }
                                                                        reshuffled={
                                                                            reshuffled
                                                                        }
                                                                    />
                                                                )}
                                                        </div>
                                                    )
                                                )}
                                            </>
                                        )}
                                    </div>
                                </>
                            )}
                        </>
                    )}
                </div>

                {showDeleteConfirm && (
                    <AlertConfirm
                        show={showDeleteConfirm}
                        setShow={setShowDeleteConfirm}
                        modalBody={deleteMessage}
                        useFunction={removeStash}
                        isConfirm
                    />
                )}

                {showUploadAlert && (
                    <PAlert
                        show={showUploadAlert}
                        setShow={setShowUploadAlert}
                        title={alertTitle}
                        body={alertBody}
                        modalStyle={{ zIndex: 100000000 }}
                    />
                )}

                {showBlockModal && (
                    <BlockUser
                        show={showBlockModal}
                        user={user}
                        handleBlockModal={handleBlockModal}
                        getBlockedUsers={getBlockedUsers}
                    />
                )}

                {showUnblockModal && (
                    <UnblockUser
                        show={showUnblockModal}
                        setShow={setShowUnblockModal}
                        user={user}
                        getBlockedUsers={getBlockedUsers}
                    />
                )}

                {userListModalRdx && <AddUserFromModal />}
                <ModalPPVPriceContext.Provider
                    value={{
                        showPrice,
                        handlePriceModalClose,
                        ppvPrice,
                        setPpvPrice,
                        promoPrice,
                        setPromoPrice,
                        isDiscounted,
                        setIsDiscounted,
                        minPpvPrice,
                        maxPpvPrice,
                        prevPpvPrice,
                        prevPromoPrice,
                        prevIsDiscounted,
                        setPrevPpvPrice,
                        setPrevPromoPrice,
                        setPrevIsDiscounted,
                        // setShowPriceInfo
                        expiry,
                        setExpiry,
                        dispatchAlert,
                    }}
                >
                    <ModalPPVPrice />
                </ModalPPVPriceContext.Provider>
            </>
        </MessageContext.Provider>
    );
};

function mapStateToProps(state) {
    return {
        stashSelected: state.stash.stashSelected,
        showPrice: state.message.showPrice,
        muteVal: state.message.mute_val,
        muteOtherVal: state.message.mute_other_val,
        msgOptionOpen: state.message.msgOptionOpen,
        showMsgLoader: state.message.showMsgLoader,
        containerClass: state.message.containerClass,
        stashModal: state.message.stashModal,
        orderModal: state.message.orderModal,
        activeAlbum: state.message.activeAlbum,
        activeConv: state.message.activeConv,
        stashSidebar: state.stash.stashSidebar,
        convIndex: state.message.convIndex,
        convList: state.message.convList,
        broadcastModal: state.message.broadcastModal,
        settings: state.privaGlobal.settings,
        show: state.stash.show,
        showChatGallery: state.chatGallery.show,
        chatGallerySource: state.chatGallery.source,
        openNotes: state.notes.isOpen,
        messages: state.message.messages,
        presence: state.user.presence,
        userListModalRdx: state.userLists.userListModal,
        userListsRdx: state.userLists.userLists,
        messageUserListsFilterRdx: state.message.userListsFilter,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        setStashSelected: (stashSelected) =>
            dispatch(setStashSelectedR(stashSelected)),
        updateShowPrice: (showPrice) => dispatch(updateShowPriceR(showPrice)),
        updateMuteHere: (mute_val) => dispatch(updateMute(mute_val)),
        updateMuteOtherHere: (mute_other_val) =>
            dispatch(updateMuteOther(mute_other_val)),
        updateConvList: (convList) => dispatch(updateConvListR(convList)),
        updateMsgOptionOpen: (msgOptionOpen) =>
            dispatch(updateMsgOptionOpenR(msgOptionOpen)),
        updateBroadcastMsg: (broadcastMsg) =>
            dispatch(updateBroadcastMsgR(broadcastMsg)),
        updateshowVideoModal: (showVideoModal) =>
            dispatch(updateshowVideoModalR(showVideoModal)),
        updateImageModalSrc: (imageModalSrc) =>
            dispatch(updateImageModalSrcR(imageModalSrc)),
        setContainerClass: (medias) => dispatch(setContainerClass(medias)),
        updateShowImageModal: (showImageModal) =>
            dispatch(updateShowImageModalR(showImageModal)),
        setStashModal: (stashModal) => dispatch(setStashModal(stashModal)),
        setOrderModal: (orderModal) => dispatch(setOrderModal(orderModal)),
        setActiveAlbum: (activeAlbum) => dispatch(setActiveAlbum(activeAlbum)),
        updateActiveConv: (activeConv) =>
            dispatch(updateActiveConvR(activeConv)),
        setStashSidebar: (stashSidebar) =>
            dispatch(setStashSidebar(stashSidebar)),
        setBroadcastModal: (broadcastModal) =>
            dispatch(setBroadcastModal(broadcastModal)),
        setSettings: (params) => dispatch(setSettings(params)),

        setStashShow: (params) => dispatch(setStashShow(params)),
        setStash: (payload) => dispatch(setStash(payload)),
        setConvIndex: (convIndex) => dispatch(setConvIndexR(convIndex)),
        setChatWindow: (payload) => dispatch(setMessages(payload)),
        updateBroadcastIndicator: (payload) =>
            dispatch(updateBroadcastIndicator(payload)),
        setStashTabSelected: (payload) =>
            dispatch(setStashTabSelected(payload)),
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(React.memo(MessengerContainer));
